export default {
    zh: {
        // SEO Meta
        pageTitle: 'Wan 2.5 AI 图像生成器 - 阿里巴巴免费 AI 图像工具',
        pageDescription:
            'Wan 2.5 由阿里巴巴开发，是其先进的 AI 图像模型，它擅长将详细的想法转化为精确、高质量的视觉效果，并能更好地控制风格、纹理和编辑。立即在 微鲤AI 图像生成器上免费试用。',
        pageKeywords:
            'Wan AI 模型, Wan 2.5 模型, 阿里巴巴 AI 模型, Wan 图像生成器, 文生图 AI, AI 绘画工具, AI 视觉创作',

        // Open Graph
        ogTitle: 'Wan 2.5 AI 图像生成器 - 阿里巴巴免费 AI 图像工具',
        ogDescription:
            'Wan 2.5 将详细创意转化为高质量 AI 图像，具备先进的风格与编辑控制能力。',

        // Additional SEO Meta
        subject: 'Wan 2.5 AI 图像生成器（阿里巴巴）',
        topic: 'AI 图像生成、文本转图像、AI 绘画模型',
        coverage: 'CN, Worldwide',
        audience: '设计师、艺术家、内容创作者、开发者',

        // Twitter Card
        twitterTitle: 'Wan 2.5 AI 图像生成器 - 阿里巴巴免费 AI 图像工具',
        twitterDescription:
            '体验 Wan 2.5 的高质量 AI 图像生成能力，现在即可免费试用！',

        // Generator Section
        generatorTitle: 'Wan 2.5 AI 图像生成器',
        generatorSubtitle:
            'Wan 2.5 由阿里巴巴开发，是其先进的 AI 图像模型，它擅长将详细的想法转化为精确、高质量的视觉效果，并能更好地控制风格、纹理和编辑。立即在 微鲤AI 图像生成器上免费试用。',

        // Core Features Section
        coreFeaturesTitle: 'Wan 2.5 核心功能特性',
        coreFeaturesSubtitle:
            '探索 Wan 2.5 AI 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // Features
        precisePromptTitle: '精准遵循提示词',
        precisePromptDesc: '精确反映每一个视觉指令，从光照、视角到纹理和风格。',
        precisePromptAlt: '精准遵循提示词示例',

        photoRealisticTitle: '照片级真实感',
        photoRealisticDesc:
            '呈现逼真的图像，具有真实的光照、空间深度和精细的纹理。',
        photoRealisticAlt: '照片级真实感示例',

        diverseStylesTitle: '多样的艺术风格',
        diverseStylesDesc:
            '忠实地重现各种艺术风格，同时保持品牌基调和视觉语言。',
        diverseStylesAlt: '多样的艺术风格示例',

        creativeTextTitle: '创意文本生成',
        creativeTextDesc: '完美设计复杂的排版、布局和海报构图。',
        creativeTextAlt: '创意文本生成示例',

        consistentElementsTitle: '一致的元素',
        consistentElementsDesc: '准确传输参考元素，以获得统一的设计和角色。',
        consistentElementsAlt: '一致的元素示例',

        preciseEditingTitle: '精确图像编辑',
        preciseEditingDesc: '理解并以高精度执行风格更改和受控编辑。',
        preciseEditingAlt: '精确图像编辑示例',

        // How to Use Section
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',

        step1Title: '选择模型',
        step1Description: '在 AI 图像工具中选择 Wan AI 模型',

        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',

        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube Videos Section
        youtubeTitle: '关于 Wan 2.5 图像模型的 YouTube 视频',

        // X Posts Section
        xPostsTitle: '关于 Wan 2.5 图像模型的 X 帖子',

        // Explore Other Models Section
        exploreModelsTitle: '在 微鲤AI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ Section
        faqTitle: '常见问题解答',

        faq1Question: '什么是 Wan AI？',
        faq1Answer:
            'Wan 2.5 由阿里巴巴开发，是一个先进的 AI 图像模型，擅长将详细的创意转化为精确、高质量的视觉效果，并提供出色的风格、纹理和编辑控制能力。',

        faq2Question: 'Wan AI 与其他图像生成模型相比有哪些优势？',
        faq2Answer:
            'Wan AI 在图像质量、创意表达、风格控制、多模态融合方面具有显著优势，能够生成专业级高质量图像，并支持复杂的创意内容。',

        faq3Question: '我能免费使用 Wan AI 吗？',
        faq3Answer:
            '可以。Wan AI 提供来自 微鲤AI 的有限免费试用额度，若需要更大规模使用，可选择升级方案。',

        faq4Question: 'Wan AI 支持哪些图像格式？',
        faq4Answer:
            'Wan AI 支持包括 JPG、PNG、WEBP 等多种通用图像格式，生成的图像质量高、细节丰富。',

        faq5Question: '我可以使用 Wan AI 用于商业项目吗？',
        faq5Answer:
            '可以。Wan AI 拥有高精度图像生成和复杂创意表达能力，非常适合设计、艺术、内容创作等商业用途。',

        // CTA Section
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Wan 2.5，将您的创意转化为精彩图像',
        ctaButton: '立即体验 Wan AI',
        ctaDisclaimer: '无需信用卡',
    },
    en: {
        // SEO Meta
        pageTitle: 'Wan 2.5 AI Image Generator by Alibaba - Free AI Image Tool',
        pageDescription:
            'Wan 2.5 by Alibaba is an advanced AI image model that excels at transforming detailed ideas into precise, high-quality visuals with superior control over style, texture, and editing. Try Wan 2.5 for free on 微鲤AI image generator!',
        pageKeywords:
            'Wan AI, Wan 2.5 AI model, Alibaba Wan, Wan image generator, Wan text to image, Wan 2.5 creator model, Alibaba AI image model',

        // Open Graph
        ogTitle: 'Wan 2.5 AI Image Generator by Alibaba - Free AI Image Tool',
        ogDescription:
            'Wan 2.5 by Alibaba is an advanced AI image model that excels at transforming detailed ideas into precise, high-quality visuals with superior control over style, texture, and editing.',

        // Twitter Card
        twitterTitle:
            'Wan 2.5 AI Image Generator by Alibaba - Free AI Image Tool',
        twitterDescription:
            'Wan 2.5 by Alibaba excels at transforming detailed ideas into precise, high-quality visuals. Try for free!',

        // Additional SEO Meta
        subject: 'Wan 2.5 AI Image Generator by Alibaba',
        topic: 'AI Image Generation, Text-to-Image, Wan AI Model',
        coverage: 'Worldwide',
        audience: 'Designers, creators, developers, artists',

        // Generator Section
        generatorTitle: 'Wan 2.5 AI Image Generator',
        generatorSubtitle:
            'Wan 2.5 by Alibaba is an advanced AI image model that excels at transforming detailed ideas into precise, high-quality visuals with superior control over style, texture, and editing. Try Wan 2.5 for free on 微鲤AI image generator!',

        // Core Features Section
        coreFeaturesTitle: 'Wan 2.5 Core Features',
        coreFeaturesSubtitle:
            'Explore the core features of Wan 2.5 AI image generator and embark on a revolutionary AI image creation journey',

        // Features
        precisePromptTitle: 'Precise Prompt Following',
        precisePromptDesc:
            'Accurately reflects every visual instruction, from lighting and perspective to texture and style.',
        precisePromptAlt: 'Precise Prompt Following Example',

        photoRealisticTitle: 'Photo-Realistic Quality',
        photoRealisticDesc:
            'Renders lifelike images with authentic lighting, spatial depth, and fine textures.',
        photoRealisticAlt: 'Photo-Realistic Quality Example',

        diverseStylesTitle: 'Diverse Artistic Styles',
        diverseStylesDesc:
            'Faithfully reproduces various artistic styles while maintaining brand tone and visual language.',
        diverseStylesAlt: 'Diverse Artistic Styles Example',

        creativeTextTitle: 'Creative Text Generation',
        creativeTextDesc:
            'Perfectly designs complex typography, layouts, and poster compositions.',
        creativeTextAlt: 'Creative Text Generation Example',

        consistentElementsTitle: 'Consistent Elements',
        consistentElementsDesc:
            'Accurately transfers reference elements for unified design and characters.',
        consistentElementsAlt: 'Consistent Elements Example',

        preciseEditingTitle: 'Precise Image Editing',
        preciseEditingDesc:
            'Understands and executes style changes and controlled edits with high precision.',
        preciseEditingAlt: 'Precise Image Editing Example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Wan AI model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos About Wan 2.5 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Wan 2.5 Image Model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Wan AI?',
        faq1Answer:
            'Wan 2.5 by Alibaba is an advanced AI image model that excels at transforming detailed ideas into precise, high-quality visuals with superior control over style, texture, and editing.',

        faq2Question:
            'What advantages does Wan AI have over other image generation models?',
        faq2Answer:
            'Wan AI has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',

        faq3Question: 'Can I use Wan AI for free?',
        faq3Answer:
            "Yes. Wan AI offers limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.",

        faq4Question: 'What image formats does Wan AI support?',
        faq4Answer:
            'Wan AI supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',

        faq5Question: 'Can I use Wan AI for commercial projects?',
        faq5Answer:
            "Yes. Wan AI's high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.",

        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Wan 2.5 now and transform your creativity into amazing images',
        ctaButton: 'Try Wan AI on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    ja: {
        // 日语翻译
        pageTitle: 'Wan 2.5 AI画像ジェネレーター - Alibaba提供無料AIツール',
        pageDescription:
            'AlibabaのWan 2.5は、詳細なアイデアを正確で高品質なビジュアルに変換することに優れた先進的なAI画像モデルです。スタイル、テクスチャ、編集を優れたコントロールで実現します。WeryAI画像ジェネレーターで無料でWan 2.5をお試しください！',
        pageKeywords:
            'Wan 2.5, Alibaba, AI画像生成, AIアート, 人工知能, 画像編集, スタイルコントロール, テキストから画像',
        ogTitle: 'Wan 2.5 AI画像ジェネレーター - Alibaba提供無料AIツール',
        ogDescription:
            'AlibabaのWan 2.5は、詳細なアイデアを正確で高品質なビジュアルに変換することに優れた先進的なAI画像モデルです。スタイル、テクスチャ、編集を優れたコントロールで実現します。',
        twitterTitle: 'Wan 2.5 AI画像ジェネレーター - Alibaba提供無料AIツール',
        twitterDescription:
            'AlibabaのWan 2.5は、詳細なアイデアを正確で高品質なビジュアルに変換することに優れています。無料でお試しください！',

        // Additional SEO Meta
        subject: 'Wan 2.5 AI画像ジェネレーター by Alibaba',
        topic: 'AI画像生成, テキストから画像, Wan AIモデル',
        coverage: 'JP, Worldwide',
        audience: 'デザイナー, クリエイター, アーティスト, 開発者',

        generatorTitle: 'Wan 2.5 AI画像ジェネレーター',
        generatorSubtitle:
            'AlibabaのWan 2.5は、詳細なアイデアを正確で高品質なビジュアルに変換することに優れた先進的なAI画像モデルです。スタイル、テクスチャ、編集を優れたコントロールで実現します。WeryAI画像ジェネレーターで無料でWan 2.5をお試しください！',
        coreFeaturesTitle: 'Wan 2.5の主な機能',
        coreFeaturesSubtitle:
            'Wan 2.5 AI画像ジェネレーターの主な機能を探索し、革新的なAI画像作成の旅に出ましょう',
        precisePromptTitle: '精確なプロンプトフォローイング',
        precisePromptDesc:
            '照明や視点からテクスチャやスタイルまで、すべての視覚的指示を正確に反映します。',
        precisePromptAlt: '精確なプロンプトフォローイングの例',
        photoRealisticTitle: '写真のようなリアルな品質',
        photoRealisticDesc:
            '本物の照明、空間的深さ、繊細なテクスチャで生き生きとした画像をレンダリングします。',
        photoRealisticAlt: '写真のようなリアルな品質の例',
        diverseStylesTitle: '多様な芸術スタイル',
        diverseStylesDesc:
            'ブランドのトーンと視覚言語を維持しながら、様々な芸術スタイルを忠実に再現します。',
        diverseStylesAlt: '多様な芸術スタイルの例',
        creativeTextTitle: 'クリエイティブなテキスト生成',
        creativeTextDesc:
            '複雑なタイポグラフィ、レイアウト、ポスター構成を完璧にデザインします。',
        creativeTextAlt: 'クリエイティブなテキスト生成の例',
        consistentElementsTitle: '一貫した要素',
        consistentElementsDesc:
            '統一されたデザインとキャラクターのために参照要素を正確に転送します。',
        consistentElementsAlt: '一貫した要素の例',
        preciseEditingTitle: '精密な画像編集',
        preciseEditingDesc:
            'スタイルの変更と制御された編集を高精度で理解し実行します。',
        preciseEditingAlt: '精密な画像編集の例',
        howToUseTitle: '使い方',
        howToUseSubtitle: '簡単3ステップで開始',
        step1Title: 'モデルを選択',
        step1Description: 'AI画像ツールでWan AIモデルを選択',
        step2Title: 'コンテンツを入力',
        step2Description: 'プロンプトを入力または参照画像をアップロード',
        step3Title: '画像を生成',
        step3Description: '生成ボタンをクリックし、待機して画像をダウンロード',
        youtubeTitle: 'Wan 2.5画像モデルについてのYouTube動画',
        xPostsTitle: 'Wan 2.5画像モデルについてのX投稿',
        exploreModelsTitle: 'WeryAIで他のAI画像モデルを探索',
        model1Title: 'Google Nano Banana AI画像ジェネレーター',
        model2Title: 'FLUX AI画像ジェネレーター',
        model3Title: 'Google Imagen AI画像ジェネレーター',
        faqTitle: 'よくある質問',
        faq1Question: 'Wan AIとは何ですか？',
        faq1Answer:
            'AlibabaのWan 2.5は、詳細なアイデアを正確で高品質なビジュアルに変換することに優れた先進的なAI画像モデルです。スタイル、テクスチャ、編集を優れたコントロールで実現します。',
        faq2Question:
            'Wan AIは他の画像生成モデルと比べてどのような利点がありますか？',
        faq2Answer:
            'Wan AIは、画像品質、クリエイティブ表現、スタイルコントロール、マルチモーダル融合において大きな利点があります。高品質なプロフェッショナルグレードの画像を生成でき、複雑なクリエイティブ表現をサポートします。',
        faq3Question: 'Wan AIを無料で使用できますか？',
        faq3Answer:
            'はい。Wan AIはWeryAIの無料トライアルを通じて限定的な無料クレジットを提供しています。大量使用の場合はアップグレードが必要です。',
        faq4Question: 'Wan AIはどのような画像形式をサポートしていますか？',
        faq4Answer:
            'Wan AIはJPG、PNG、WEBPなどの一般的な形式を含む様々な画像形式をサポートしています。生成された画像は高品質で豊富な詳細を特徴としています。',
        faq5Question: 'Wan AIを商業プロジェクトに使用できますか？',
        faq5Answer:
            'はい。Wan AIの高精度画像生成とクリエイティブ表現機能は、高品質なAI生成画像を求めるデザイナー、アーティスト、コンテンツクリエーターにとって強力な選択肢となります。',
        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription:
            '今すぐWan 2.5を体験し、あなたのアイデアを素晴らしい画像に変換',
        ctaButton: 'Try Wan AI on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    ko: {
        // 韩语翻译
        pageTitle: 'Wan 2.5 AI 이미지 생성기 - Alibaba 제공 무료 AI 도구',
        pageDescription:
            'Alibaba의 Wan 2.5는 상세한 아이디어를 정확하고 고품질의 비주얼로 변환하는 데 탁월한 선진적인 AI 이미지 모델입니다. 스타일, 텍스처, 편집에 대한 우수한 제어 기능을 제공합니다. 微鲤AI 이미지 생성기에서 무료로 Wan 2.5를 체험하세요!',
        pageKeywords:
            'Wan 2.5, Alibaba, AI 이미지 생성, AI 아트, 인공지능, 이미지 편집, 스타일 제어, 텍스트에서 이미지',
        ogTitle: 'Wan 2.5 AI 이미지 생성기 - Alibaba 제공 무료 AI 도구',
        ogDescription:
            'Alibaba의 Wan 2.5는 상세한 아이디어를 정확하고 고품질의 비주얼로 변환하는 데 탁월한 선진적인 AI 이미지 모델입니다. 스타일, 텍스처, 편집에 대한 우수한 제어 기능을 제공합니다.',
        twitterTitle: 'Wan 2.5 AI 이미지 생성기 - Alibaba 제공 무료 AI 도구',
        twitterDescription:
            'Alibaba의 Wan 2.5는 상세한 아이디어를 정확하고 고품질의 비주얼로 변환하는 데 탁월합니다. 무료로 체험하세요!',

        // Additional SEO Meta
        subject: 'Wan 2.5 AI 이미지 생성기 by Alibaba',
        topic: 'AI 이미지 생성, 텍스트 투 이미지, Wan AI 모델',
        coverage: 'KR, Worldwide',
        audience: '디자이너, 크리에이터, 아티스트, 개발자',
        generatorTitle: 'Wan 2.5 AI 이미지 생성기',
        generatorSubtitle:
            'Alibaba의 Wan 2.5는 상세한 아이디어를 정확하고 고품질의 비주얼로 변환하는 데 탁월한 선진적인 AI 이미지 모델입니다. 스타일, 텍스처, 편집에 대한 우수한 제어 기능을 제공합니다. 微鲤AI 이미지 생성기에서 무료로 Wan 2.5를 체험하세요!',
        coreFeaturesTitle: 'Wan 2.5의 주요 기능',
        coreFeaturesSubtitle:
            'Wan 2.5 AI 이미지 생성기의 주요 기능을 탐색하고 혁신적인 AI 이미지 제작 여정을 시작하세요',
        precisePromptTitle: '정확한 프롬프트 추종',
        precisePromptDesc:
            '조명과 관점에서 텍스처와 스타일까지 모든 시각적 지시를 정확하게 반영합니다.',
        precisePromptAlt: '정확한 프롬프트 추종 예시',
        photoRealisticTitle: '사진과 같은 사실적 품질',
        photoRealisticDesc:
            '진정한 조명, 공간 깊이, 섬세한 텍스처로 생생한 이미지를 렌더링합니다.',
        photoRealisticAlt: '사진과 같은 사실적 품질 예시',
        diverseStylesTitle: '다양한 예술 스타일',
        diverseStylesDesc:
            '브랜드 톤과 시각적 언어를 유지하면서 다양한 예술 스타일을 충실하게 재현합니다.',
        diverseStylesAlt: '다양한 예술 스타일 예시',
        creativeTextTitle: '창의적 텍스트 생성',
        creativeTextDesc:
            '복잡한 타이포그래피, 레이아웃, 포스터 구성을 완벽하게 디자인합니다.',
        creativeTextAlt: '창의적 텍스트 생성 예시',
        consistentElementsTitle: '일관된 요소',
        consistentElementsDesc:
            '통일된 디자인과 캐릭터를 위해 참조 요소를 정확하게 전송합니다.',
        consistentElementsAlt: '일관된 요소 예시',
        preciseEditingTitle: '정밀한 이미지 편집',
        preciseEditingDesc:
            '스타일 변경과 제어된 편집을 고정밀도로 이해하고 실행합니다.',
        preciseEditingAlt: '정밀한 이미지 편집 예시',
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 시작',
        step1Title: '모델 선택',
        step1Description: 'AI 이미지 도구에서 Wan AI 모델 선택',
        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트 입력 또는 참조 이미지 업로드',
        step3Title: '이미지 생성',
        step3Description: '생성 버튼 클릭, 대기 후 이미지 다운로드',
        youtubeTitle: 'Wan 2.5 이미지 모델에 대한 YouTube 비디오',
        xPostsTitle: 'Wan 2.5 이미지 모델에 대한 X 게시물',
        exploreModelsTitle: 'WeryAI에서 다른 AI 이미지 모델 탐색',
        model1Title: 'Google Nano Banana AI 이미지 생성기',
        model2Title: 'FLUX AI 이미지 생성기',
        model3Title: 'Google Imagen AI 이미지 생성기',
        faqTitle: '자주 묻는 질문',
        faq1Question: 'Wan AI가 무엇인가요?',
        faq1Answer:
            'Alibaba의 Wan 2.5는 상세한 아이디어를 정확하고 고품질의 비주얼로 변환하는 데 탁월한 선진적인 AI 이미지 모델입니다. 스타일, 텍스처, 편집에 대한 우수한 제어 기능을 제공합니다.',
        faq2Question:
            'Wan AI는 다른 이미지 생성 모델에 비해 어떤 장점이 있나요?',
        faq2Answer:
            'Wan AI는 이미지 품질, 창의적 표현, 스타일 제어, 멀티모달 융합에서 큰 장점이 있습니다. 고품질의 전문가급 이미지를 생성할 수 있으며 복잡한 창의적 표현을 지원합니다.',
        faq3Question: 'Wan AI를 무료로 사용할 수 있나요?',
        faq3Answer:
            '네. Wan AI는 WeryAI의 무료 체험을 통해 제한된 무료 크레딧을 제공합니다. 광범위한 사용을 위해서는 업그레이드가 필요합니다.',
        faq4Question: 'Wan AI는 어떤 이미지 형식을 지원하나요?',
        faq4Answer:
            'Wan AI는 JPG, PNG, WEBP 등 일반적인 형식을 포함한 다양한 이미지 형식을 지원합니다. 생성된 이미지는 고품질과 풍부한 디테일을 특징으로 합니다.',
        faq5Question: 'Wan AI를 상업 프로젝트에 사용할 수 있나요?',
        faq5Answer:
            '네. Wan AI의 고정밀 이미지 생성과 창의적 표현 기능은 고품질 AI 생성 이미지를 찾는 디자이너, 아티스트, 콘텐츠 크리에이터에게 강력한 선택이 됩니다.',
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription:
            '지금 Wan 2.5를 체험하고 당신의 아이디어를 놀라운 이미지로 변환하세요',
        ctaButton: 'Try Wan AI on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    tw: {

        // SEO Meta
        pageTitle: 'Wan 2.5 AI 图像生成器 - 阿里巴巴免费 AI 图像工具',
        pageDescription:
            'Wan 2.5 由阿里巴巴开发，是其先进的 AI 图像模型，它擅长将详细的想法转化为精确、高质量的视觉效果，并能更好地控制风格、纹理和编辑。立即在 微鲤AI 图像生成器上免费试用。',
        pageKeywords:
            'Wan AI 模型, Wan 2.5 模型, 阿里巴巴 AI 模型, Wan 图像生成器, 文生图 AI, AI 绘画工具, AI 视觉创作',

        // Open Graph
        ogTitle: 'Wan 2.5 AI 图像生成器 - 阿里巴巴免费 AI 图像工具',
        ogDescription:
            'Wan 2.5 将详细创意转化为高质量 AI 图像，具备先进的风格与编辑控制能力。',

        // Additional SEO Meta
        subject: 'Wan 2.5 AI 图像生成器（阿里巴巴）',
        topic: 'AI 图像生成、文本转图像、AI 绘画模型',
        coverage: 'CN, Worldwide',
        audience: '设计师、艺术家、内容创作者、开发者',

        // Twitter Card
        twitterTitle: 'Wan 2.5 AI 图像生成器 - 阿里巴巴免费 AI 图像工具',
        twitterDescription:
            '体验 Wan 2.5 的高质量 AI 图像生成能力，现在即可免费试用！',

        // Generator Section
        generatorTitle: 'Wan 2.5 AI 图像生成器',
        generatorSubtitle:
            'Wan 2.5 由阿里巴巴开发，是其先进的 AI 图像模型，它擅长将详细的想法转化为精确、高质量的视觉效果，并能更好地控制风格、纹理和编辑。立即在 微鲤AI 图像生成器上免费试用。',

        // Core Features Section
        coreFeaturesTitle: 'Wan 2.5 核心功能特性',
        coreFeaturesSubtitle:
            '探索 Wan 2.5 AI 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // Features
        precisePromptTitle: '精准遵循提示词',
        precisePromptDesc: '精确反映每一个视觉指令，从光照、视角到纹理和风格。',
        precisePromptAlt: '精准遵循提示词示例',

        photoRealisticTitle: '照片级真实感',
        photoRealisticDesc:
            '呈现逼真的图像，具有真实的光照、空间深度和精细的纹理。',
        photoRealisticAlt: '照片级真实感示例',

        diverseStylesTitle: '多样的艺术风格',
        diverseStylesDesc:
            '忠实地重现各种艺术风格，同时保持品牌基调和视觉语言。',
        diverseStylesAlt: '多样的艺术风格示例',

        creativeTextTitle: '创意文本生成',
        creativeTextDesc: '完美设计复杂的排版、布局和海报构图。',
        creativeTextAlt: '创意文本生成示例',

        consistentElementsTitle: '一致的元素',
        consistentElementsDesc: '准确传输参考元素，以获得统一的设计和角色。',
        consistentElementsAlt: '一致的元素示例',

        preciseEditingTitle: '精确图像编辑',
        preciseEditingDesc: '理解并以高精度执行风格更改和受控编辑。',
        preciseEditingAlt: '精确图像编辑示例',

        // How to Use Section
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',

        step1Title: '选择模型',
        step1Description: '在 AI 图像工具中选择 Wan AI 模型',

        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',

        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube Videos Section
        youtubeTitle: '关于 Wan 2.5 图像模型的 YouTube 视频',

        // X Posts Section
        xPostsTitle: '关于 Wan 2.5 图像模型的 X 帖子',

        // Explore Other Models Section
        exploreModelsTitle: '在 微鲤AI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ Section
        faqTitle: '常见问题解答',

        faq1Question: '什么是 Wan AI？',
        faq1Answer:
            'Wan 2.5 由阿里巴巴开发，是一个先进的 AI 图像模型，擅长将详细的创意转化为精确、高质量的视觉效果，并提供出色的风格、纹理和编辑控制能力。',

        faq2Question: 'Wan AI 与其他图像生成模型相比有哪些优势？',
        faq2Answer:
            'Wan AI 在图像质量、创意表达、风格控制、多模态融合方面具有显著优势，能够生成专业级高质量图像，并支持复杂的创意内容。',

        faq3Question: '我能免费使用 Wan AI 吗？',
        faq3Answer:
            '可以。Wan AI 提供来自 微鲤AI 的有限免费试用额度，若需要更大规模使用，可选择升级方案。',

        faq4Question: 'Wan AI 支持哪些图像格式？',
        faq4Answer:
            'Wan AI 支持包括 JPG、PNG、WEBP 等多种通用图像格式，生成的图像质量高、细节丰富。',

        faq5Question: '我可以使用 Wan AI 用于商业项目吗？',
        faq5Answer:
            '可以。Wan AI 拥有高精度图像生成和复杂创意表达能力，非常适合设计、艺术、内容创作等商业用途。',

        // CTA Section
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Wan 2.5，将您的创意转化为精彩图像',
        ctaButton: '立即体验 Wan AI',
        ctaDisclaimer: '无需信用卡',
    },
    pl: {

        // SEO Meta
        pageTitle: 'Wan 2.5 AI Image Generator by Alibaba - Free AI Image Tool',
        pageDescription:
            'Wan 2.5 by Alibaba is an advanced AI image model that excels at transforming detailed ideas into precise, high-quality visuals with superior control over style, texture, and editing. Try Wan 2.5 for free on 微鲤AI image generator!',
        pageKeywords:
            'Wan AI, Wan 2.5 AI model, Alibaba Wan, Wan image generator, Wan text to image, Wan 2.5 creator model, Alibaba AI image model',

        // Open Graph
        ogTitle: 'Wan 2.5 AI Image Generator by Alibaba - Free AI Image Tool',
        ogDescription:
            'Wan 2.5 by Alibaba is an advanced AI image model that excels at transforming detailed ideas into precise, high-quality visuals with superior control over style, texture, and editing.',

        // Twitter Card
        twitterTitle:
            'Wan 2.5 AI Image Generator by Alibaba - Free AI Image Tool',
        twitterDescription:
            'Wan 2.5 by Alibaba excels at transforming detailed ideas into precise, high-quality visuals. Try for free!',

        // Additional SEO Meta
        subject: 'Wan 2.5 AI Image Generator by Alibaba',
        topic: 'AI Image Generation, Text-to-Image, Wan AI Model',
        coverage: 'Worldwide',
        audience: 'Designers, creators, developers, artists',

        // Generator Section
        generatorTitle: 'Wan 2.5 AI Image Generator',
        generatorSubtitle:
            'Wan 2.5 by Alibaba is an advanced AI image model that excels at transforming detailed ideas into precise, high-quality visuals with superior control over style, texture, and editing. Try Wan 2.5 for free on 微鲤AI image generator!',

        // Core Features Section
        coreFeaturesTitle: 'Wan 2.5 Core Features',
        coreFeaturesSubtitle:
            'Explore the core features of Wan 2.5 AI image generator and embark on a revolutionary AI image creation journey',

        // Features
        precisePromptTitle: 'Precise Prompt Following',
        precisePromptDesc:
            'Accurately reflects every visual instruction, from lighting and perspective to texture and style.',
        precisePromptAlt: 'Precise Prompt Following Example',

        photoRealisticTitle: 'Photo-Realistic Quality',
        photoRealisticDesc:
            'Renders lifelike images with authentic lighting, spatial depth, and fine textures.',
        photoRealisticAlt: 'Photo-Realistic Quality Example',

        diverseStylesTitle: 'Diverse Artistic Styles',
        diverseStylesDesc:
            'Faithfully reproduces various artistic styles while maintaining brand tone and visual language.',
        diverseStylesAlt: 'Diverse Artistic Styles Example',

        creativeTextTitle: 'Creative Text Generation',
        creativeTextDesc:
            'Perfectly designs complex typography, layouts, and poster compositions.',
        creativeTextAlt: 'Creative Text Generation Example',

        consistentElementsTitle: 'Consistent Elements',
        consistentElementsDesc:
            'Accurately transfers reference elements for unified design and characters.',
        consistentElementsAlt: 'Consistent Elements Example',

        preciseEditingTitle: 'Precise Image Editing',
        preciseEditingDesc:
            'Understands and executes style changes and controlled edits with high precision.',
        preciseEditingAlt: 'Precise Image Editing Example',

        // How to Use Section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to start creating',

        step1Title: 'Select Model',
        step1Description: 'Choose Wan AI model in AI image tools',

        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',

        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube Videos Section
        youtubeTitle: 'YouTube Videos About Wan 2.5 Image Model',

        // X Posts Section
        xPostsTitle: 'X Posts About Wan 2.5 Image Model',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Other AI Image Models on 微鲤AI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'FLUX AI Image Generator',
        model3Title: 'Google Imagen AI Image Generator',

        // FAQ Section
        faqTitle: 'Frequently Asked Questions',

        faq1Question: 'What is Wan AI?',
        faq1Answer:
            'Wan 2.5 by Alibaba is an advanced AI image model that excels at transforming detailed ideas into precise, high-quality visuals with superior control over style, texture, and editing.',

        faq2Question:
            'What advantages does Wan AI have over other image generation models?',
        faq2Answer:
            'Wan AI has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',

        faq3Question: 'Can I use Wan AI for free?',
        faq3Answer:
            "Yes. Wan AI offers limited free credits through 微鲤AI\'s free trial. For extensive use, an upgrade is required.",

        faq4Question: 'What image formats does Wan AI support?',
        faq4Answer:
            'Wan AI supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',

        faq5Question: 'Can I use Wan AI for commercial projects?',
        faq5Answer:
            "Yes. Wan AI's high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.",

        // CTA Section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Wan 2.5 now and transform your creativity into amazing images',
        ctaButton: 'Try Wan AI on 微鲤AI',
        ctaDisclaimer: 'No credit card required',
    },
    es: {
        // SEO Meta
        pageTitle:
            'Generador de Imágenes IA Wan 2.5 de Alibaba - Herramienta IA Gratuita',
        pageDescription:
            'Wan 2.5 de Alibaba es un modelo avanzado de imágenes IA que sobresale en transformar ideas detalladas en visuales precisos y de alta calidad con un control superior sobre el estilo, textura y edición. ¡Prueba Wan 2.5 gratis en el generador de imágenes 微鲤AI!',
        pageKeywords:
            'Wan AI, modelo Wan 2.5, IA de Alibaba, generador de imágenes Wan, modelo IA Wan, texto a imagen IA, creación visual IA',

        // Open Graph
        ogTitle:
            'Generador de Imágenes IA Wan 2.5 de Alibaba - Herramienta IA Gratuita',
        ogDescription:
            'Wan 2.5 de Alibaba es un modelo avanzado de imágenes IA que sobresale en transformar ideas detalladas en visuales precisos y de alta calidad con un control superior sobre el estilo, textura y edición.',

        // Additional SEO Meta
        subject: 'Generador de Imágenes IA Wan 2.5 de Alibaba',
        topic: 'Generación de imágenes IA, texto a imagen, modelo Wan AI',
        coverage: 'ES, Worldwide',
        audience: 'Diseñadores, artistas, creadores, desarrolladores',

        // Twitter Card
        twitterTitle:
            'Generador de Imágenes IA Wan 2.5 de Alibaba - Herramienta IA Gratuita',
        twitterDescription:
            'Wan 2.5 de Alibaba sobresale en transformar ideas detalladas en visuales precisos y de alta calidad. ¡Prueba gratis!',

        // Generator Section
        generatorTitle: 'Generador de Imágenes IA Wan 2.5',
        generatorSubtitle:
            'Wan 2.5 de Alibaba es un modelo avanzado de imágenes IA que sobresale en transformar ideas detalladas en visuales precisos y de alta calidad con un control superior sobre el estilo, textura y edición. ¡Prueba Wan 2.5 gratis en el generador de imágenes 微鲤AI!',

        // Core Features Section
        coreFeaturesTitle: 'Características Principales de Wan 2.5',
        coreFeaturesSubtitle:
            'Explora las características principales del generador de imágenes IA Wan 2.5 y embárcate en un viaje revolucionario de creación de imágenes IA',

        // Features
        precisePromptTitle: 'Seguimiento Preciso de Prompts',
        precisePromptDesc:
            'Refleja con precisión cada instrucción visual, desde la iluminación y perspectiva hasta la textura y el estilo.',
        precisePromptAlt: 'Ejemplo de Seguimiento Preciso de Prompts',

        photoRealisticTitle: 'Calidad Fotorrealista',
        photoRealisticDesc:
            'Renderiza imágenes realistas con iluminación auténtica, profundidad espacial y texturas finas.',
        photoRealisticAlt: 'Ejemplo de Calidad Fotorrealista',

        diverseStylesTitle: 'Diversos Estilos Artísticos',
        diverseStylesDesc:
            'Reproduce fielmente varios estilos artísticos manteniendo el tono de marca y el lenguaje visual.',
        diverseStylesAlt: 'Ejemplo de Diversos Estilos Artísticos',

        creativeTextTitle: 'Generación de Texto Creativo',
        creativeTextDesc:
            'Diseña perfectamente tipografías complejas, diseños y composiciones de pósters.',
        creativeTextAlt: 'Ejemplo de Generación de Texto Creativo',

        consistentElementsTitle: 'Elementos Consistentes',
        consistentElementsDesc:
            'Transfiere con precisión elementos de referencia para un diseño y personajes unificados.',
        consistentElementsAlt: 'Ejemplo de Elementos Consistentes',

        preciseEditingTitle: 'Edición Precisa de Imágenes',
        preciseEditingDesc:
            'Comprende y ejecuta cambios de estilo y ediciones controladas con alta precisión.',
        preciseEditingAlt: 'Ejemplo de Edición Precisa de Imágenes',

        // How to Use Section
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Tres simples pasos para comenzar a crear',

        step1Title: 'Seleccionar Modelo',
        step1Description:
            'Elige el modelo Wan AI en las herramientas de imagen IA',

        step2Title: 'Ingresar Contenido',
        step2Description: 'Introduce prompts o sube imágenes de referencia',

        step3Title: 'Generar Imagen',
        step3Description:
            'Haz clic en el botón generar, espera y descarga tu imagen',

        // YouTube Videos Section
        youtubeTitle: 'Videos de YouTube sobre el Modelo de Imagen Wan 2.5',

        // X Posts Section
        xPostsTitle: 'Publicaciones de X sobre el Modelo de Imagen Wan 2.5',

        // Explore Other Models Section
        exploreModelsTitle: 'Explora Otros Modelos de Imagen IA en 微鲤AI',
        model1Title: 'Generador de Imágenes IA Google Nano Banana',
        model2Title: 'Generador de Imágenes IA FLUX',
        model3Title: 'Generador de Imágenes IA Google Imagen',

        // FAQ Section
        faqTitle: 'Preguntas Frecuentes',

        faq1Question: '¿Qué es Wan AI?',
        faq1Answer:
            'Wan 2.5 de Alibaba es un modelo avanzado de imágenes IA que transforma ideas detalladas en visuales precisos y de alta calidad con control superior sobre estilo, textura y edición.',

        faq2Question:
            '¿Qué ventajas tiene Wan AI sobre otros modelos de generación de imágenes?',
        faq2Answer:
            'Wan AI ofrece ventajas en calidad de imagen, expresión creativa, control de estilo y fusión multimodal. Genera imágenes profesionales de alta calidad y soporta expresiones creativas complejas.',

        faq3Question: '¿Puedo usar Wan AI gratis?',
        faq3Answer:
            'Sí. Wan AI ofrece créditos gratuitos limitados mediante la prueba gratuita de 微鲤AI. Para un uso más amplio, se requiere una actualización.',

        faq4Question: '¿Qué formatos de imagen soporta Wan AI?',
        faq4Answer:
            'Wan AI soporta formatos como JPG, PNG y WEBP. Las imágenes generadas son de alta calidad y cuentan con detalles ricos.',

        faq5Question: '¿Puedo usar Wan AI para proyectos comerciales?',
        faq5Answer:
            'Sí. Las capacidades avanzadas de generación y expresión creativa de Wan AI son ideales para diseñadores, artistas y creadores que necesitan imágenes IA de alta calidad para uso comercial.',

        // CTA Section
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaDescription:
            'Experimenta Wan 2.5 ahora y transforma tus ideas en imágenes increíbles',
        ctaButton: 'Prueba Wan AI en 微鲤AI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',
    },
    fr: {
        // SEO Meta
        pageTitle:
            "Générateur d'Images IA Wan 2.5 par Alibaba - Outil IA Gratuit",
        pageDescription:
            "Wan 2.5 par Alibaba est un modèle d'images IA avancé qui excelle à transformer des idées détaillées en visuels précis et de haute qualité avec un contrôle supérieur du style, de la texture et de l'édition. Essayez Wan 2.5 gratuitement sur le générateur d'images 微鲤AI !",
        pageKeywords:
            "Wan AI, modèle Wan 2.5, modèle IA Alibaba, générateur d'images IA Wan, modèle IA Wan, texte vers image IA, création visuelle IA",

        // Open Graph
        ogTitle:
            "Générateur d'Images IA Wan 2.5 par Alibaba - Outil IA Gratuit",
        ogDescription:
            "Wan 2.5 par Alibaba est un modèle d'images IA avancé qui excelle à transformer des idées détaillées en visuels précis et de haute qualité avec un contrôle supérieur du style, de la texture et de l'édition.",

        // Additional SEO Meta
        subject: "Générateur d'Images IA Wan 2.5 par Alibaba",
        topic: "Génération d'images IA, texte vers image, modèle Wan AI",
        coverage: 'FR, Worldwide',
        audience: 'Designers, artistes, créateurs de contenu, développeurs',

        // Twitter Card
        twitterTitle:
            "Générateur d'Images IA Wan 2.5 par Alibaba - Outil IA Gratuit",
        twitterDescription:
            'Wan 2.5 par Alibaba excelle à transformer des idées détaillées en visuels précis et de haute qualité. Essayez gratuitement !',

        // Generator Section
        generatorTitle: "Générateur d'Images IA Wan 2.5",
        generatorSubtitle:
            "Wan 2.5 par Alibaba est un modèle d'images IA avancé qui excelle à transformer des idées détaillées en visuels précis et de haute qualité avec un contrôle supérieur du style, de la texture et de l'édition. Essayez Wan 2.5 gratuitement sur le générateur d'images 微鲤AI !",

        // Core Features Section
        coreFeaturesTitle: 'Fonctionnalités Principales de Wan 2.5',
        coreFeaturesSubtitle:
            "Explorez les fonctionnalités principales du générateur d'images IA Wan 2.5 et lancez-vous dans un voyage révolutionnaire de création d'images IA",

        // Features
        precisePromptTitle: 'Suivi Précis des Prompts',
        precisePromptDesc:
            "Reflète avec précision chaque instruction visuelle, de l'éclairage et de la perspective à la texture et au style.",
        precisePromptAlt: 'Exemple de Suivi Précis des Prompts',

        photoRealisticTitle: 'Qualité Photoréaliste',
        photoRealisticDesc:
            'Rend des images réalistes avec un éclairage authentique, une profondeur spatiale et des textures fines.',
        photoRealisticAlt: 'Exemple de Qualité Photoréaliste',

        diverseStylesTitle: 'Styles Artistiques Divers',
        diverseStylesDesc:
            'Reproduit fidèlement divers styles artistiques tout en maintenant le ton de la marque et le langage visuel.',
        diverseStylesAlt: 'Exemple de Styles Artistiques Divers',

        creativeTextTitle: 'Génération de Texte Créatif',
        creativeTextDesc:
            "Conçoit parfaitement des typographies complexes, des mises en page et des compositions d'affiches.",
        creativeTextAlt: 'Exemple de Génération de Texte Créatif',

        consistentElementsTitle: 'Éléments Cohérents',
        consistentElementsDesc:
            'Transfère avec précision les éléments de référence pour un design et des personnages unifiés.',
        consistentElementsAlt: "Exemple d'Éléments Cohérents",

        preciseEditingTitle: "Édition Précise d'Images",
        preciseEditingDesc:
            'Comprend et exécute des changements de style et des modifications contrôlées avec une haute précision.',
        preciseEditingAlt: "Exemple d'Édition Précise d'Images",

        // How to Use Section
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Trois étapes simples pour commencer à créer',

        step1Title: 'Sélectionner le Modèle',
        step1Description:
            "Choisissez le modèle Wan AI dans les outils d'image IA",

        step2Title: 'Entrer le Contenu',
        step2Description:
            'Saisissez des prompts ou téléchargez des images de référence',

        step3Title: "Générer l'Image",
        step3Description:
            'Cliquez sur le bouton générer, attendez et téléchargez votre image',

        // YouTube Videos Section
        youtubeTitle: "Vidéos YouTube sur le Modèle d'Image Wan 2.5",

        // X Posts Section
        xPostsTitle: "Publications X sur le Modèle d'Image Wan 2.5",

        // Explore Other Models Section
        exploreModelsTitle: "Explorez d'Autres Modèles d'Image IA sur 微鲤AI",
        model1Title: "Générateur d'Images IA Google Nano Banana",
        model2Title: "Générateur d'Images IA FLUX",
        model3Title: "Générateur d'Images IA Google Imagen",

        // FAQ Section
        faqTitle: 'Questions Fréquemment Posées',

        faq1Question: "Qu'est-ce que Wan AI ?",
        faq1Answer:
            "Wan 2.5 par Alibaba est un modèle d'images IA avancé qui excelle à transformer des idées détaillées en visuels précis et de haute qualité avec un contrôle supérieur du style, de la texture et de l'édition.",

        faq2Question:
            "Quels avantages Wan AI a-t-il par rapport aux autres modèles de génération d'images ?",
        faq2Answer:
            "Wan AI présente des avantages significatifs en matière de qualité d'image, d'expression créative, de contrôle du style et de fusion multimodale. Il peut générer des images de qualité professionnelle et supporte une expression créative complexe.",

        faq3Question: 'Puis-je utiliser Wan AI gratuitement ?',
        faq3Answer:
            "Oui. Wan AI offre des crédits gratuits limités via l'essai gratuit de 微鲤AI. Pour une utilisation extensive, une mise à niveau est nécessaire.",

        faq4Question: "Quels formats d'image Wan AI supporte-t-il ?",
        faq4Answer:
            "Wan AI supporte divers formats d'image dont JPG, PNG, WEBP et autres formats courants. Les images générées présentent une haute qualité et des détails riches.",

        faq5Question: 'Puis-je utiliser Wan AI pour des projets commerciaux ?',
        faq5Answer:
            "Oui. Les capacités de génération d'images haute précision et d'expression créative de Wan AI en font un choix puissant pour les designers, artistes et créateurs de contenu recherchant des images générées par IA de haute qualité.",

        // CTA Section
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaDescription:
            'Découvrez Wan 2.5 maintenant et transformez vos idées en images incroyables',
        ctaButton: 'Essayez Wan AI sur 微鲤AI',
        ctaDisclaimer: 'Aucune carte de crédit requise',
    },
    de: {
        // SEO Meta
        pageTitle: 'Wan 2.5 KI-Bildgenerator von Alibaba - Kostenloses KI-Tool',
        pageDescription:
            'Wan 2.5 von Alibaba ist ein fortschrittliches KI-Bildmodell, das detaillierte Ideen hervorragend in präzise, hochwertige Visuals mit überlegener Kontrolle über Stil, Textur und Bearbeitung umwandelt. Testen Sie Wan 2.5 kostenlos auf dem 微鲤AI Bildgenerator!',
        pageKeywords:
            'Wan AI, Wan 2.5 Modell, Alibaba KI-Modell, KI-Bildgenerator Wan, KI-Modell Wan, Text-zu-Bild KI, visuelle KI-Erstellung',

        // Open Graph
        ogTitle: 'Wan 2.5 KI-Bildgenerator von Alibaba - Kostenloses KI-Tool',
        ogDescription:
            'Wan 2.5 von Alibaba ist ein fortschrittliches KI-Bildmodell, das detaillierte Ideen hervorragend in präzise, hochwertige Visuals mit überlegener Kontrolle über Stil, Textur und Bearbeitung umwandelt.',

        // Additional SEO Meta
        subject: 'Wan 2.5 KI-Bildgenerator von Alibaba',
        topic: 'KI-Bildgenerierung, Text zu Bild, Wan AI Modell',
        coverage: 'DE, Worldwide',
        audience: 'Designer, Künstler, Entwickler, Content-Ersteller',

        // Twitter Card
        twitterTitle:
            'Wan 2.5 KI-Bildgenerator von Alibaba - Kostenloses KI-Tool',
        twitterDescription:
            'Wan 2.5 von Alibaba wandelt detaillierte Ideen hervorragend in präzise, hochwertige Visuals um. Kostenlos testen!',

        // Generator Section
        generatorTitle: 'Wan 2.5 KI-Bildgenerator',
        generatorSubtitle:
            'Wan 2.5 von Alibaba ist ein fortschrittliches KI-Bildmodell, das detaillierte Ideen hervorragend in präzise, hochwertige Visuals mit überlegener Kontrolle über Stil, Textur und Bearbeitung umwandelt. Testen Sie Wan 2.5 kostenlos auf dem 微鲤AI Bildgenerator!',

        // Core Features Section
        coreFeaturesTitle: 'Wan 2.5 Kernfunktionen',
        coreFeaturesSubtitle:
            'Erkunden Sie die Kernfunktionen des Wan 2.5 KI-Bildgenerators und begeben Sie sich auf eine revolutionäre KI-Bilderstellungsreise',

        // Features
        precisePromptTitle: 'Präzise Prompt-Befolgung',
        precisePromptDesc:
            'Reflektiert präzise jede visuelle Anweisung, von Beleuchtung und Perspektive bis zu Textur und Stil.',
        precisePromptAlt: 'Beispiel für Präzise Prompt-Befolgung',

        photoRealisticTitle: 'Fotorealistische Qualität',
        photoRealisticDesc:
            'Rendert lebensechte Bilder mit authentischer Beleuchtung, räumlicher Tiefe und feinen Texturen.',
        photoRealisticAlt: 'Beispiel für Fotorealistische Qualität',

        diverseStylesTitle: 'Vielfältige Künstlerische Stile',
        diverseStylesDesc:
            'Reproduziert treu verschiedene künstlerische Stile und behält dabei den Markenton und die visuelle Sprache bei.',
        diverseStylesAlt: 'Beispiel für Vielfältige Künstlerische Stile',

        creativeTextTitle: 'Kreative Textgenerierung',
        creativeTextDesc:
            'Gestaltet perfekt komplexe Typografie, Layouts und Posterkompositionen.',
        creativeTextAlt: 'Beispiel für Kreative Textgenerierung',

        consistentElementsTitle: 'Konsistente Elemente',
        consistentElementsDesc:
            'Überträgt präzise Referenzelemente für einheitliches Design und Charaktere.',
        consistentElementsAlt: 'Beispiel für Konsistente Elemente',

        preciseEditingTitle: 'Präzise Bildbearbeitung',
        preciseEditingDesc:
            'Versteht und führt Stiländerungen und kontrollierte Bearbeitungen mit hoher Präzision aus.',
        preciseEditingAlt: 'Beispiel für Präzise Bildbearbeitung',

        // How to Use Section
        howToUseTitle: 'Wie Man Verwendet',
        howToUseSubtitle: 'Drei einfache Schritte zum Erstellen',

        step1Title: 'Modell Auswählen',
        step1Description:
            'Wählen Sie das Wan AI-Modell in den KI-Bildwerkzeugen',

        step2Title: 'Inhalt Eingeben',
        step2Description:
            'Geben Sie Prompts ein oder laden Sie Referenzbilder hoch',

        step3Title: 'Bild Generieren',
        step3Description:
            'Klicken Sie auf die Generieren-Schaltfläche, warten Sie und laden Sie Ihr Bild herunter',

        // YouTube Videos Section
        youtubeTitle: 'YouTube-Videos über das Wan 2.5 Bildmodell',

        // X Posts Section
        xPostsTitle: 'X-Beiträge über das Wan 2.5 Bildmodell',

        // Explore Other Models Section
        exploreModelsTitle: 'Erkunden Sie Andere KI-Bildmodelle auf 微鲤AI',
        model1Title: 'Google Nano Banana KI-Bildgenerator',
        model2Title: 'FLUX KI-Bildgenerator',
        model3Title: 'Google Imagen KI-Bildgenerator',

        // FAQ Section
        faqTitle: 'Häufig Gestellte Fragen',

        faq1Question: 'Was ist Wan AI?',
        faq1Answer:
            'Wan 2.5 von Alibaba ist ein fortschrittliches KI-Bildmodell, das detaillierte Ideen in präzise, hochwertige Visuals mit überlegener Kontrolle über Stil, Textur und Bearbeitung umwandelt.',

        faq2Question:
            'Welche Vorteile hat Wan AI gegenüber anderen Bildgenerierungsmodellen?',
        faq2Answer:
            'Wan AI bietet erhebliche Vorteile in Bildqualität, kreativem Ausdruck, Stilkontrolle und multimodaler Fusion. Es erzeugt Bilder in professioneller Qualität und unterstützt komplexe kreative Konzepte.',

        faq3Question: 'Kann ich Wan AI kostenlos verwenden?',
        faq3Answer:
            'Ja. Wan AI bietet begrenzte kostenlose Credits über die 微鲤AI-Testversion. Für intensivere Nutzung ist ein Upgrade erforderlich.',

        faq4Question: 'Welche Bildformate unterstützt Wan AI?',
        faq4Answer:
            'Wan AI unterstützt Bildformate wie JPG, PNG und WEBP. Die generierten Bilder sind hochqualitativ und detailreich.',

        faq5Question: 'Kann ich Wan AI für kommerzielle Projekte verwenden?',
        faq5Answer:
            'Ja. Dank seiner hochpräzisen Bildgenerierung und kreativen Ausdrucksfähigkeiten eignet sich Wan AI hervorragend für Designer, Künstler und Content-Ersteller, die hochwertige KI-Bilder für kommerzielle Zwecke benötigen.',

        // CTA Section
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription:
            'Erleben Sie Wan 2.5 jetzt und verwandeln Sie Ihre Ideen in erstaunliche Bilder',
        ctaButton: 'Testen Sie Wan AI auf 微鲤AI',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',
    },
    ru: {
        // SEO Meta
        pageTitle:
            'Генератор изображений Wan 2.5 AI от Alibaba - Бесплатный инструмент ИИ',
        pageDescription:
            'Wan 2.5 от Alibaba - это продвинутая модель изображений AI, которая превосходно преобразует детальные идеи в точные, высококачественные визуальные образы с превосходным контролем над стилем, текстурой и редактированием. Попробуйте Wan 2.5 бесплатно на генераторе изображений 微鲤AI!',
        pageKeywords:
            'Wan AI, модель Wan 2.5, AI-модель Alibaba, генератор изображений Wan, AI-модель Wan, текст-в-изображение ИИ, визуальная генерация ИИ',

        // Open Graph
        ogTitle:
            'Генератор изображений Wan 2.5 AI от Alibaba - Бесплатный инструмент ИИ',
        ogDescription:
            'Wan 2.5 от Alibaba - это продвинутая модель изображений AI, которая превосходно преобразует детальные идеи в точные, высококачественные визуальные образы с превосходным контролем над стилем, текстурой и редактированием.',

        // Additional SEO Meta
        subject: 'Генератор изображений Wan 2.5 AI от Alibaba',
        topic: 'AI-генерация изображений, текст в изображение, модель Wan AI',
        coverage: 'RU, Worldwide',
        audience: 'Дизайнеры, художники, разработчики, создатели контента',

        // Twitter Card
        twitterTitle:
            'Генератор изображений Wan 2.5 AI от Alibaba - Бесплатный инструмент ИИ',
        twitterDescription:
            'Wan 2.5 от Alibaba превосходно преобразует детальные идеи в точные, высококачественные визуальные образы. Попробуйте бесплатно!',

        // Generator Section
        generatorTitle: 'Генератор изображений Wan 2.5 AI',
        generatorSubtitle:
            'Wan 2.5 от Alibaba - это продвинутая модель изображений AI, которая превосходно преобразует детальные идеи в точные, высококачественные визуальные образы с превосходным контролем над стилем, текстурой и редактированием. Попробуйте Wan 2.5 бесплатно на генераторе изображений 微鲤AI!',

        // Core Features Section
        coreFeaturesTitle: 'Основные функции Wan 2.5',
        coreFeaturesSubtitle:
            'Изучите основные функции генератора изображений Wan 2.5 AI и отправьтесь в революционное путешествие по созданию изображений AI',

        // Features
        precisePromptTitle: 'Точное следование промптам',
        precisePromptDesc:
            'Точно отражает каждую визуальную инструкцию, от освещения и перспективы до текстуры и стиля.',
        precisePromptAlt: 'Пример точного следования промптам',

        photoRealisticTitle: 'Фотореалистичное качество',
        photoRealisticDesc:
            'Создает реалистичные изображения с аутентичным освещением, пространственной глубиной и тонкими текстурами.',
        photoRealisticAlt: 'Пример фотореалистичного качества',

        diverseStylesTitle: 'Разнообразные художественные стили',
        diverseStylesDesc:
            'Верно воспроизводит различные художественные стили, сохраняя тон бренда и визуальный язык.',
        diverseStylesAlt: 'Пример разнообразных художественных стилей',

        creativeTextTitle: 'Креативная генерация текста',
        creativeTextDesc:
            'Идеально создает сложную типографику, макеты и композиции плакатов.',
        creativeTextAlt: 'Пример креативной генерации текста',

        consistentElementsTitle: 'Последовательные элементы',
        consistentElementsDesc:
            'Точно переносит референсные элементы для единого дизайна и персонажей.',
        consistentElementsAlt: 'Пример последовательных элементов',

        preciseEditingTitle: 'Точное редактирование изображений',
        preciseEditingDesc:
            'Понимает и выполняет изменения стиля и контролируемые правки с высокой точностью.',
        preciseEditingAlt: 'Пример точного редактирования изображений',

        // How to Use Section
        howToUseTitle: 'Как использовать',
        howToUseSubtitle: 'Три простых шага для начала создания',

        step1Title: 'Выберите модель',
        step1Description:
            'Выберите модель Wan AI в инструментах AI-изображений',

        step2Title: 'Введите содержимое',
        step2Description:
            'Введите промпты или загрузите референсные изображения',

        step3Title: 'Сгенерируйте изображение',
        step3Description:
            'Нажмите кнопку генерации, дождитесь и скачайте изображение',

        // YouTube Videos Section
        youtubeTitle: 'Видео на YouTube о модели изображений Wan 2.5',

        // X Posts Section
        xPostsTitle: 'Посты в X о модели изображений Wan 2.5',

        // Explore Other Models Section
        exploreModelsTitle: 'Исследуйте другие модели AI-изображений на 微鲤AI',
        model1Title: 'Генератор изображений Google Nano Banana AI',
        model2Title: 'Генератор изображений FLUX AI',
        model3Title: 'Генератор изображений Google Imagen AI',

        // FAQ Section
        faqTitle: 'Часто задаваемые вопросы',

        faq1Question: 'Что такое Wan AI?',
        faq1Answer:
            'Wan 2.5 от Alibaba — это продвинутая AI-модель, которая преобразует детальные идеи в точные, высококачественные визуальные образы с превосходным контролем над стилем, текстурой и редактированием.',

        faq2Question:
            'Какие преимущества имеет Wan AI перед другими моделями генерации изображений?',
        faq2Answer:
            'Wan AI имеет значительные преимущества в качестве изображений, творческом выражении, контроле стиля и мультимодальном слиянии. Она создаёт изображения профессионального уровня и поддерживает сложные творческие задачи.',

        faq3Question: 'Могу ли я использовать Wan AI бесплатно?',
        faq3Answer:
            'Да. Wan AI предоставляет ограниченные бесплатные кредиты через бесплатную пробную версию 微鲤AI. Для широкого использования требуется обновление.',

        faq4Question: 'Какие форматы изображений поддерживает Wan AI?',
        faq4Answer:
            'Wan AI поддерживает JPG, PNG, WEBP и другие распространённые форматы. Созданные изображения отличаются высокой детализацией и качеством.',

        faq5Question:
            'Могу ли я использовать Wan AI для коммерческих проектов?',
        faq5Answer:
            'Да. Благодаря высокой точности генерации и возможностям творческого выражения Wan AI отлично подходит для дизайнеров, художников и создателей контента, которым нужны высококачественные AI-изображения.',

        // CTA Section
        ctaTitle: 'Готовы начать создавать?',
        ctaDescription:
            'Испытайте Wan 2.5 сейчас и превратите свои идеи в потрясающие изображения',
        ctaButton: 'Попробуйте Wan AI на 微鲤AI',
        ctaDisclaimer: 'Кредитная карта не требуется',
    },
    pt: {
        // SEO Meta
        pageTitle:
            'Gerador de Imagens IA Wan 2.5 da Alibaba - Ferramenta IA Gratuita',
        pageDescription:
            'Wan 2.5 da Alibaba é um modelo avançado de imagens IA que se destaca em transformar ideias detalhadas em visuais precisos e de alta qualidade com controle superior sobre estilo, textura e edição. Experimente Wan 2.5 gratuitamente no gerador de imagens 微鲤AI!',
        pageKeywords:
            'Wan AI, modelo Wan 2.5, IA da Alibaba, gerador de imagens Wan, modelo IA Wan, texto para imagem IA, criação visual IA',

        // Open Graph
        ogTitle:
            'Gerador de Imagens IA Wan 2.5 da Alibaba - Ferramenta IA Gratuita',
        ogDescription:
            'Wan 2.5 da Alibaba é um modelo avançado de imagens IA que se destaca em transformar ideias detalhadas em visuais precisos e de alta qualidade com controle superior sobre estilo, textura e edição.',

        // Additional SEO Meta
        subject: 'Gerador de Imagens IA Wan 2.5 da Alibaba',
        topic: 'Geração de imagens IA, texto para imagem, modelo Wan AI',
        coverage: 'PT, Worldwide',
        audience: 'Designers, artistas, criadores de conteúdo, desenvolvedores',

        // Twitter Card
        twitterTitle:
            'Gerador de Imagens IA Wan 2.5 da Alibaba - Ferramenta IA Gratuita',
        twitterDescription:
            'Wan 2.5 da Alibaba se destaca em transformar ideias detalhadas em visuais precisos e de alta qualidade. Experimente grátis!',

        // Generator Section
        generatorTitle: 'Gerador de Imagens IA Wan 2.5',
        generatorSubtitle:
            'Wan 2.5 da Alibaba é um modelo avançado de imagens IA que se destaca em transformar ideias detalhadas em visuais precisos e de alta qualidade com controle superior sobre estilo, textura e edição. Experimente Wan 2.5 gratuitamente no gerador de imagens 微鲤AI!',

        // Core Features Section
        coreFeaturesTitle: 'Recursos Principais do Wan 2.5',
        coreFeaturesSubtitle:
            'Explore os recursos principais do gerador de imagens IA Wan 2.5 e embarque em uma jornada revolucionária de criação de imagens IA',

        // Features
        precisePromptTitle: 'Seguimento Preciso de Prompts',
        precisePromptDesc:
            'Reflete com precisão cada instrução visual, desde iluminação e perspectiva até textura e estilo.',
        precisePromptAlt: 'Exemplo de Seguimento Preciso de Prompts',

        photoRealisticTitle: 'Qualidade Fotorrealista',
        photoRealisticDesc:
            'Renderiza imagens realistas com iluminação autêntica, profundidade espacial e texturas finas.',
        photoRealisticAlt: 'Exemplo de Qualidade Fotorrealista',

        diverseStylesTitle: 'Estilos Artísticos Diversos',
        diverseStylesDesc:
            'Reproduz fielmente vários estilos artísticos mantendo o tom da marca e a linguagem visual.',
        diverseStylesAlt: 'Exemplo de Estilos Artísticos Diversos',

        creativeTextTitle: 'Geração de Texto Criativo',
        creativeTextDesc:
            'Projeta perfeitamente tipografias complexas, layouts e composições de pôsteres.',
        creativeTextAlt: 'Exemplo de Geração de Texto Criativo',

        consistentElementsTitle: 'Elementos Consistentes',
        consistentElementsDesc:
            'Transfere com precisão elementos de referência para design e personagens unificados.',
        consistentElementsAlt: 'Exemplo de Elementos Consistentes',

        preciseEditingTitle: 'Edição Precisa de Imagens',
        preciseEditingDesc:
            'Compreende e executa mudanças de estilo e edições controladas com alta precisão.',
        preciseEditingAlt: 'Exemplo de Edição Precisa de Imagens',

        // How to Use Section
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Três passos simples para começar a criar',

        step1Title: 'Selecionar Modelo',
        step1Description:
            'Escolha o modelo Wan AI nas ferramentas de imagem IA',

        step2Title: 'Inserir Conteúdo',
        step2Description: 'Digite prompts ou carregue imagens de referência',

        step3Title: 'Gerar Imagem',
        step3Description: 'Clique no botão gerar, aguarde e baixe sua imagem',

        // YouTube Videos Section
        youtubeTitle: 'Vídeos do YouTube sobre o Modelo de Imagem Wan 2.5',

        // X Posts Section
        xPostsTitle: 'Posts do X sobre o Modelo de Imagem Wan 2.5',

        // Explore Other Models Section
        exploreModelsTitle: 'Explore Outros Modelos de Imagem IA no 微鲤AI',
        model1Title: 'Gerador de Imagens IA Google Nano Banana',
        model2Title: 'Gerador de Imagens IA FLUX',
        model3Title: 'Gerador de Imagens IA Google Imagen',

        // FAQ Section
        faqTitle: 'Perguntas Frequentes',

        faq1Question: 'O que é Wan AI?',
        faq1Answer:
            'Wan 2.5 da Alibaba é um modelo avançado de imagens IA que transforma ideias detalhadas em visuais precisos e de alta qualidade, com controle avançado de estilo, textura e edição.',

        faq2Question:
            'Quais vantagens o Wan AI tem sobre outros modelos de geração de imagens?',
        faq2Answer:
            'Wan AI possui vantagens significativas em qualidade de imagem, expressão criativa, controle de estilo e fusão multimodal. Ele gera imagens profissionais de alta qualidade e suporta conceitos criativos complexos.',

        faq3Question: 'Posso usar o Wan AI gratuitamente?',
        faq3Answer:
            'Sim. O Wan AI oferece créditos gratuitos limitados através do teste gratuito do 微鲤AI. Para uso mais amplo, é necessário atualizar.',

        faq4Question: 'Quais formatos de imagem o Wan AI suporta?',
        faq4Answer:
            'O Wan AI suporta formatos como JPG, PNG e WEBP. As imagens geradas têm alta qualidade e riqueza de detalhes.',

        faq5Question: 'Posso usar o Wan AI para projetos comerciais?',
        faq5Answer:
            'Sim. As capacidades avançadas de geração de imagens e expressão criativa do Wan AI o tornam ideal para designers, artistas e criadores que precisam de imagens IA de alta qualidade para uso comercial.',

        // CTA Section
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription:
            'Experimente o Wan 2.5 agora e transforme suas ideias em imagens incríveis',
        ctaButton: 'Experimente o Wan AI no 微鲤AI',
        ctaDisclaimer: 'Não é necessário cartão de crédito',
    },
    it: {
        // SEO Meta
        pageTitle:
            'Generatore di Immagini IA Wan 2.5 di Alibaba - Strumento IA Gratuito',
        pageDescription:
            'Wan 2.5 di Alibaba è un modello avanzato di immagini IA che eccelle nel trasformare idee dettagliate in immagini precise e di alta qualità con un controllo superiore su stile, texture ed editing. Prova Wan 2.5 gratuitamente sul generatore di immagini 微鲤AI!',
        pageKeywords:
            'Wan AI, modello Wan 2.5, IA Alibaba, generatore immagini Wan, modello IA Wan, testo in immagine IA, creazione visiva IA',

        // Open Graph
        ogTitle:
            'Generatore di Immagini IA Wan 2.5 di Alibaba - Strumento IA Gratuito',
        ogDescription:
            'Wan 2.5 di Alibaba è un modello avanzato di immagini IA che eccelle nel trasformare idee dettagliate in immagini precise e di alta qualità con un controllo superiore su stile, texture ed editing.',

        // Additional SEO Meta
        subject: 'Generatore di Immagini IA Wan 2.5 di Alibaba',
        topic: 'Generazione immagini IA, testo in immagine, modello Wan AI',
        coverage: 'IT, Worldwide',
        audience: 'Designer, artisti, creatori di contenuti, sviluppatori',

        // Twitter Card
        twitterTitle:
            'Generatore di Immagini IA Wan 2.5 di Alibaba - Strumento IA Gratuito',
        twitterDescription:
            'Wan 2.5 di Alibaba eccelle nel trasformare idee dettagliate in immagini precise e di alta qualità. Prova gratis!',

        // Generator Section
        generatorTitle: 'Generatore di Immagini IA Wan 2.5',
        generatorSubtitle:
            'Wan 2.5 di Alibaba è un modello avanzato di immagini IA che eccelle nel trasformare idee dettagliate in immagini precise e di alta qualità con un controllo superiore su stile, texture ed editing. Prova Wan 2.5 gratuitamente sul generatore di immagini 微鲤AI!',

        // Core Features Section
        coreFeaturesTitle: 'Caratteristiche Principali di Wan 2.5',
        coreFeaturesSubtitle:
            'Esplora le caratteristiche principali del generatore di immagini IA Wan 2.5 e intraprendi un viaggio rivoluzionario nella creazione di immagini IA',

        // Features
        precisePromptTitle: 'Seguimento Preciso dei Prompt',
        precisePromptDesc:
            "Riflette con precisione ogni istruzione visiva, dall'illuminazione e dalla prospettiva alla texture e allo stile.",
        precisePromptAlt: 'Esempio di Seguimento Preciso dei Prompt',

        photoRealisticTitle: 'Qualità Fotorealistica',
        photoRealisticDesc:
            'Renderizza immagini realistiche con illuminazione autentica, profondità spaziale e texture fini.',
        photoRealisticAlt: 'Esempio di Qualità Fotorealistica',

        diverseStylesTitle: 'Diversi Stili Artistici',
        diverseStylesDesc:
            'Riproduce fedelmente vari stili artistici mantenendo il tono del marchio e il linguaggio visivo.',
        diverseStylesAlt: 'Esempio di Diversi Stili Artistici',

        creativeTextTitle: 'Generazione di Testo Creativo',
        creativeTextDesc:
            'Progetta perfettamente tipografie complesse, layout e composizioni di poster.',
        creativeTextAlt: 'Esempio di Generazione di Testo Creativo',

        consistentElementsTitle: 'Elementi Coerenti',
        consistentElementsDesc:
            'Trasferisce con precisione elementi di riferimento per design e personaggi unificati.',
        consistentElementsAlt: 'Esempio di Elementi Coerenti',

        preciseEditingTitle: 'Modifica Precisa delle Immagini',
        preciseEditingDesc:
            'Comprende ed esegue cambiamenti di stile e modifiche controllate con alta precisione.',
        preciseEditingAlt: 'Esempio di Modifica Precisa delle Immagini',

        // How to Use Section
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Tre semplici passaggi per iniziare a creare',

        step1Title: 'Seleziona Modello',
        step1Description:
            'Scegli il modello Wan AI negli strumenti di immagini IA',

        step2Title: 'Inserisci Contenuto',
        step2Description: 'Inserisci prompt o carica immagini di riferimento',

        step3Title: 'Genera Immagine',
        step3Description:
            'Clicca sul pulsante genera, attendi e scarica la tua immagine',

        // YouTube Videos Section
        youtubeTitle: 'Video di YouTube sul Modello di Immagine Wan 2.5',

        // X Posts Section
        xPostsTitle: 'Post di X sul Modello di Immagine Wan 2.5',

        // Explore Other Models Section
        exploreModelsTitle: 'Esplora Altri Modelli di Immagine IA su 微鲤AI',
        model1Title: 'Generatore di Immagini IA Google Nano Banana',
        model2Title: 'Generatore di Immagini IA FLUX',
        model3Title: 'Generatore di Immagini IA Google Imagen',

        // FAQ Section
        faqTitle: 'Domande Frequenti',

        faq1Question: "Cos'è Wan AI?",
        faq1Answer:
            'Wan 2.5 di Alibaba è un modello avanzato di immagini IA che trasforma idee dettagliate in immagini precise e di alta qualità con controllo avanzato su stile, texture ed editing.',

        faq2Question:
            'Quali vantaggi ha Wan AI rispetto ad altri modelli di generazione di immagini?',
        faq2Answer:
            "Wan AI offre vantaggi significativi in qualità dell'immagine, espressione creativa, controllo dello stile e fusione multimodale. Genera immagini professionali di alta qualità e supporta concetti creativi complessi.",

        faq3Question: 'Posso usare Wan AI gratuitamente?',
        faq3Answer:
            'Sì. Wan AI offre crediti gratuiti limitati tramite la prova gratuita di 微鲤AI. Per un utilizzo più ampio, è necessario effettuare un upgrade.',

        faq4Question: 'Quali formati di immagine supporta Wan AI?',
        faq4Answer:
            'Wan AI supporta formati come JPG, PNG e WEBP. Le immagini generate presentano alta qualità e ricchi dettagli.',

        faq5Question: 'Posso usare Wan AI per progetti commerciali?',
        faq5Answer:
            'Sì. Le capacità avanzate di generazione di immagini e di espressione creativa rendono Wan AI ideale per designer, artisti e creatori di contenuti che necessitano di immagini IA di alta qualità per uso commerciale.',

        // CTA Section
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaDescription:
            'Prova Wan 2.5 ora e trasforma le tue idee in immagini straordinarie',
        ctaButton: 'Prova Wan AI su 微鲤AI',
        ctaDisclaimer: 'Non è richiesta la carta di credito',
    },
    ar: {
        // SEO Meta
        pageTitle:
            'مولد الصور بالذكاء الاصطناعي Wan 2.5 من Alibaba - أداة ذكاء اصطناعي مجانية',
        pageDescription:
            'Wan 2.5 من Alibaba هو نموذج متقدم للصور بالذكاء الاصطناعي يتفوق في تحويل الأفكار التفصيلية إلى صور مرئية دقيقة وعالية الجودة مع تحكم متفوق في الأسلوب والملمس والتحرير. جرب Wan 2.5 مجانًا على مولد الصور 微鲤AI!',
        pageKeywords:
            'Wan AI, نموذج Wan 2.5, نموذج ذكاء اصطناعي Alibaba, مولد صور Wan, نموذج AI Wan, تحويل النص إلى صورة, إنشاء صور بالذكاء الاصطناعي',

        // Open Graph
        ogTitle:
            'مولد الصور بالذكاء الاصطناعي Wan 2.5 من Alibaba - أداة ذكاء اصطناعي مجانية',
        ogDescription:
            'Wan 2.5 من Alibaba يحول الأفكار التفصيلية إلى صور دقيقة وعالية الجودة بفضل التحكم المتقدم في الأسلوب.',

        // Additional SEO Meta
        subject: 'مولد الصور بالذكاء الاصطناعي Wan 2.5 من Alibaba',
        topic: 'توليد الصور بالذكاء الاصطناعي، تحويل النص إلى صورة، نموذج Wan AI',
        coverage: 'AR, Worldwide',
        audience: 'مصممين، فنانين، مطورين، صناع محتوى',

        // Twitter Card
        twitterTitle:
            'مولد الصور بالذكاء الاصطناعي Wan 2.5 من Alibaba - أداة ذكاء اصطناعي مجانية',
        twitterDescription:
            'اختبر قدرة Wan 2.5 على إنشاء صور دقيقة وعالية الجودة باستخدام الذكاء الاصطناعي. جربه الآن مجانًا!',

        // Generator Section
        generatorTitle: 'مولد الصور بالذكاء الاصطناعي Wan 2.5',
        generatorSubtitle:
            'Wan 2.5 من Alibaba هو نموذج متقدم للصور بالذكاء الاصطناعي يتفوق في تحويل الأفكار التفصيلية إلى صور مرئية دقيقة وعالية الجودة مع تحكم متفوق في الأسلوب والملمس والتحرير. جرب Wan 2.5 مجانًا على مولد الصور 微鲤AI!',

        // Core Features Section
        coreFeaturesTitle: 'الميزات الأساسية لـ Wan 2.5',
        coreFeaturesSubtitle:
            'استكشف الميزات الأساسية لمولد الصور بالذكاء الاصطناعي Wan 2.5 وابدأ رحلة ثورية لإنشاء صور بالذكاء الاصطناعي',

        // Features
        precisePromptTitle: 'متابعة دقيقة للمطالبات',
        precisePromptDesc:
            'يعكس بدقة كل تعليمات بصرية، من الإضاءة والمنظور إلى الملمس والأسلوب.',
        precisePromptAlt: 'مثال على المتابعة الدقيقة للمطالبات',

        photoRealisticTitle: 'جودة واقعية فوتوغرافية',
        photoRealisticDesc:
            'يعرض صورًا واقعية بإضاءة أصلية وعمق مكاني وملمس دقيق.',
        photoRealisticAlt: 'مثال على الجودة الواقعية الفوتوغرافية',

        diverseStylesTitle: 'أنماط فنية متنوعة',
        diverseStylesDesc:
            'يعيد إنتاج أنماط فنية متنوعة بأمانة مع الحفاظ على نبرة العلامة التجارية واللغة البصرية.',
        diverseStylesAlt: 'مثال على الأنماط الفنية المتنوعة',

        creativeTextTitle: 'توليد نص إبداعي',
        creativeTextDesc:
            'يصمم بشكل مثالي الطباعة المعقدة والتخطيطات وتركيبات الملصقات.',
        creativeTextAlt: 'مثال على توليد النص الإبداعي',

        consistentElementsTitle: 'عناصر متسقة',
        consistentElementsDesc:
            'ينقل بدقة عناصر المرجع للحصول على تصميم وشخصيات موحدة.',
        consistentElementsAlt: 'مثال على العناصر المتسقة',

        preciseEditingTitle: 'تحرير دقيق للصور',
        preciseEditingDesc:
            'يفهم وينفذ تغييرات الأسلوب والتعديلات المضبوطة بدقة عالية.',
        preciseEditingAlt: 'مثال على التحرير الدقيق للصور',

        // How to Use Section
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ثلاث خطوات بسيطة لبدء الإنشاء',

        step1Title: 'اختر النموذج',
        step1Description: 'اختر نموذج Wan AI في أدوات الصور بالذكاء الاصطناعي',

        step2Title: 'أدخل المحتوى',
        step2Description: 'أدخل المطالبات أو قم بتحميل صور مرجعية',

        step3Title: 'أنشئ الصورة',
        step3Description: 'انقر فوق زر الإنشاء، انتظر وقم بتنزيل صورتك',

        // YouTube Videos Section
        youtubeTitle: 'فيديوهات YouTube حول نموذج الصور Wan 2.5',

        // X Posts Section
        xPostsTitle: 'منشورات X حول نموذج الصور Wan 2.5',

        // Explore Other Models Section
        exploreModelsTitle:
            'استكشف نماذج الصور بالذكاء الاصطناعي الأخرى على 微鲤AI',
        model1Title: 'مولد الصور بالذكاء الاصطناعي Google Nano Banana',
        model2Title: 'مولد الصور بالذكاء الاصطناعي FLUX',
        model3Title: 'مولد الصور بالذكاء الاصطناعي Google Imagen',

        // FAQ Section
        faqTitle: 'الأسئلة الشائعة',

        faq1Question: 'ما هو Wan AI؟',
        faq1Answer:
            'Wan 2.5 من Alibaba هو نموذج متقدم للصور بالذكاء الاصطناعي يتفوق في تحويل الأفكار التفصيلية إلى صور دقيقة وعالية الجودة مع تحكم متقدم في الأسلوب والملمس والتحرير.',

        faq2Question:
            'ما المزايا التي يتمتع بها Wan AI مقارنة بنماذج توليد الصور الأخرى؟',
        faq2Answer:
            'يمتلك Wan AI مزايا كبيرة في جودة الصورة، التعبير الإبداعي، التحكم في الأسلوب والدمج متعدد الوسائط. يمكنه إنشاء صور احترافية عالية الجودة ويدعم التعبير الإبداعي المعقد.',

        faq3Question: 'هل يمكنني استخدام Wan AI مجانًا؟',
        faq3Answer:
            'نعم. يقدم Wan AI أرصدة مجانية محدودة من خلال الإصدار التجريبي من 微鲤AI. وللاستخدام المكثف، يلزم الترقية.',

        faq4Question: 'ما تنسيقات الصور التي يدعمها Wan AI؟',
        faq4Answer:
            'يدعم Wan AI تنسيقات مثل JPG و PNG و WEBP. تتميز الصور الناتجة بجودة عالية وتفاصيل غنية.',

        faq5Question: 'هل يمكنني استخدام Wan AI للمشاريع التجارية؟',
        faq5Answer:
            'نعم. قدرات Wan AI في إنشاء الصور بدقة عالية وتوفير تعبير إبداعي متقدم تجعله مناسبًا للمصممين والفنانين ومنشئي المحتوى الذين يحتاجون إلى صور عالية الجودة للاستخدام التجاري.',

        // CTA Section
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaDescription: 'اختبر Wan 2.5 الآن وحوّل أفكارك إلى صور مذهلة',
        ctaButton: 'جرب Wan AI على 微鲤AI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',
        },
    th: {
        // SEO Meta
        pageTitle: 'เครื่องมือสร้างภาพด้วย AI Wan 2.5 จาก Alibaba - เครื่องมือสร้างภาพ AI ฟรี',
        pageDescription:
            'Wan 2.5 จาก Alibaba เป็นโมเดลภาพ AI ขั้นสูงที่แปลงไอเดียละเอียดให้เป็นภาพคุณภาพสูงอย่างแม่นยำ พร้อมควบคุมสไตล์ เท็กซ์เจอร์ และการแก้ไขได้ดี ลอง Wan 2.5 ฟรีบนเครื่องมือสร้างภาพ 微鲤AI!',
        pageKeywords:
            'Wan AI, โมเดล Wan 2.5, Alibaba Wan, เครื่องมือสร้างภาพ Wan, Wan แปลงข้อความเป็นภาพ, โมเดลสร้างภาพ Wan 2.5, โมเดลภาพ AI ของ Alibaba',

        // Open Graph
        ogTitle: 'เครื่องมือสร้างภาพด้วย AI Wan 2.5 จาก Alibaba - เครื่องมือสร้างภาพ AI ฟรี',
        ogDescription:
            'Wan 2.5 จาก Alibaba เป็นโมเดลภาพ AI ขั้นสูงที่แปลงไอเดียละเอียดให้เป็นภาพคุณภาพสูงอย่างแม่นยำ พร้อมควบคุมสไตล์ เท็กซ์เจอร์ และการแก้ไขได้ดี',

        // Twitter Card
        twitterTitle:
            'เครื่องมือสร้างภาพด้วย AI Wan 2.5 จาก Alibaba - เครื่องมือสร้างภาพ AI ฟรี',
        twitterDescription:
            'Wan 2.5 จาก Alibaba เปลี่ยนไอเดียละเอียดเป็นภาพคุณภาพสูงได้อย่างแม่นยำ ทดลองใช้ฟรีได้เลย!',

        // Additional SEO Meta
        subject: 'เครื่องมือสร้างภาพด้วย AI Wan 2.5 จาก Alibaba',
        topic: 'การสร้างภาพด้วย AI, ข้อความเป็นภาพ, โมเดล Wan AI',
        coverage: 'ทั่วโลก',
        audience: 'นักออกแบบ ผู้สร้างสรรค์ นักพัฒนา ศิลปิน',

        // Generator Section
        generatorTitle: 'เครื่องมือสร้างภาพด้วย AI Wan 2.5',
        generatorSubtitle:
            'Wan 2.5 จาก Alibaba เป็นโมเดลภาพ AI ขั้นสูงที่แปลงไอเดียละเอียดให้เป็นภาพคุณภาพสูงอย่างแม่นยำ พร้อมควบคุมสไตล์ เท็กซ์เจอร์ และการแก้ไขได้ดี ลอง Wan 2.5 ฟรีบนเครื่องมือสร้างภาพ 微鲤AI!',

        // Core Features Section
        coreFeaturesTitle: 'ฟีเจอร์หลักของ Wan 2.5',
        coreFeaturesSubtitle:
            'สำรวจฟีเจอร์หลักของเครื่องมือสร้างภาพ AI Wan 2.5 และเริ่มต้นการสร้างภาพด้วย AI อย่างปฏิวัติ',

        // Features
        precisePromptTitle: 'ทำตามพรอมต์อย่างแม่นยำ',
        precisePromptDesc:
            'ถ่ายทอดทุกคำสั่งภาพอย่างถูกต้อง ตั้งแต่แสง มุมมอง ไปจนถึงเท็กซ์เจอร์และสไตล์',
        precisePromptAlt: 'ตัวอย่างการทำตามพรอมต์อย่างแม่นยำ',

        photoRealisticTitle: 'คุณภาพสมจริงระดับภาพถ่าย',
        photoRealisticDesc:
            'เรนเดอร์ภาพเสมือนจริงด้วยแสงที่แท้จริง ความลึกเชิงพื้นที่ และเท็กซ์เจอร์ละเอียด',
        photoRealisticAlt: 'ตัวอย่างคุณภาพสมจริงระดับภาพถ่าย',

        diverseStylesTitle: 'สไตล์ศิลปะหลากหลาย',
        diverseStylesDesc:
            'ถ่ายทอดสไตล์ศิลปะหลากหลายได้อย่างซื่อตรง พร้อมคงโทนแบรนด์และภาษาภาพ',
        diverseStylesAlt: 'ตัวอย่างสไตล์ศิลปะหลากหลาย',

        creativeTextTitle: 'สร้างตัวอักษรเชิงสร้างสรรค์',
        creativeTextDesc:
            'ออกแบบตัวพิมพ์ เลย์เอาต์ และองค์ประกอบโปสเตอร์ที่ซับซ้อนได้อย่างลงตัว',
        creativeTextAlt: 'ตัวอย่างการสร้างตัวอักษรเชิงสร้างสรรค์',

        consistentElementsTitle: 'องค์ประกอบสม่ำเสมอ',
        consistentElementsDesc:
            'ถ่ายทอดองค์ประกอบอ้างอิงได้อย่างแม่นยำ เพื่อดีไซน์และตัวละครที่เป็นหนึ่งเดียว',
        consistentElementsAlt: 'ตัวอย่างองค์ประกอบสม่ำเสมอ',

        preciseEditingTitle: 'การแก้ไขภาพอย่างแม่นยำ',
        preciseEditingDesc:
            'เข้าใจและดำเนินการเปลี่ยนสไตล์และการแก้ไขแบบควบคุมได้อย่างแม่นยำ',
        preciseEditingAlt: 'ตัวอย่างการแก้ไขภาพอย่างแม่นยำ',

        // How to Use Section
        howToUseTitle: 'วิธีใช้งาน',
        howToUseSubtitle: '3 ขั้นตอนง่าย ๆ เริ่มสร้างได้ทันที',

        step1Title: 'เลือกโมเดล',
        step1Description: 'เลือกโมเดล Wan AI ในเครื่องมือสร้างภาพ AI',

        step2Title: 'ใส่เนื้อหา',
        step2Description: 'พิมพ์พรอมต์หรืออัปโหลดภาพอ้างอิง',

        step3Title: 'สร้างภาพ',
        step3Description: 'กดปุ่มสร้าง รอ และดาวน์โหลดภาพของคุณ',

        // YouTube Videos Section
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับโมเดลภาพ Wan 2.5',

        // X Posts Section
        xPostsTitle: 'โพสต์บน X เกี่ยวกับโมเดลภาพ Wan 2.5',

        // Explore Other Models Section
        exploreModelsTitle: 'สำรวจโมเดลภาพ AI อื่น ๆ บน 微鲤AI',
        model1Title: 'เครื่องมือสร้างภาพ AI Google Nano Banana',
        model2Title: 'เครื่องมือสร้างภาพ AI FLUX',
        model3Title: 'เครื่องมือสร้างภาพ AI Google Imagen',

        // FAQ Section
        faqTitle: 'คำถามที่พบบ่อย',

        faq1Question: 'Wan AI คืออะไร?',
        faq1Answer:
            'Wan 2.5 จาก Alibaba เป็นโมเดลภาพ AI ขั้นสูงที่โดดเด่นในการแปลงไอเดียละเอียดให้เป็นภาพคุณภาพสูงอย่างแม่นยำ พร้อมควบคุมสไตล์ เท็กซ์เจอร์ และการแก้ไขได้ดี',

        faq2Question:
            'Wan AI มีข้อได้เปรียบอะไรเหนือโมเดลสร้างภาพอื่น?',
        faq2Answer:
            'Wan AI เด่นด้านคุณภาพภาพ การแสดงออกเชิงสร้างสรรค์ การควบคุมสไตล์ และการผสานหลายโมดัล สร้างภาพคุณภาพระดับมืออาชีพและรองรับงานสร้างสรรค์ซับซ้อนได้',

        faq3Question: 'ฉันใช้ Wan AI ได้ฟรีไหม?',
        faq3Answer:
            'ได้ Wan AI ให้เครดิตฟรีแบบจำกัดผ่านการทดลองของ 微鲤AI หากใช้งานมากต้องอัปเกรด',

        faq4Question: 'Wan AI รองรับไฟล์ภาพแบบใด?',
        faq4Answer:
            'รองรับ JPG, PNG, WEBP และรูปแบบทั่วไปอื่น ๆ ภาพที่ได้มีคุณภาพสูงและรายละเอียดคมชัด',

        faq5Question: 'สามารถใช้ Wan AI ในงานเชิงพาณิชย์ได้ไหม?',
        faq5Answer:
            'ได้ ความแม่นยำและพลังสร้างสรรค์ของ Wan AI ทำให้เหมาะกับนักออกแบบ ศิลปิน และครีเอเตอร์ที่ต้องการภาพคุณภาพสูงสำหรับงานเชิงพาณิชย์',

        // CTA Section
        ctaTitle: 'พร้อมเริ่มสร้างแล้วหรือยัง?',
        ctaDescription:
            'ลอง Wan 2.5 ตอนนี้ และเปลี่ยนความคิดสร้างสรรค์เป็นภาพสุดพิเศษ',
        ctaButton: 'ลอง Wan AI บน 微鲤AI',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',
        },
    da: {
        // SEO Meta
        pageTitle: 'Wan 2.5 AI-billedgenerator fra Alibaba - Gratis AI-billedværktøj',
        pageDescription:
            'Wan 2.5 fra Alibaba er en avanceret AI-billedmodel, der omsætter detaljerede ideer til præcise billeder i høj kvalitet med stærk kontrol over stil, tekstur og redigering. Prøv Wan 2.5 gratis på 微鲤AI!',
        pageKeywords:
            'Wan AI, Wan 2.5 AI-model, Alibaba Wan, Wan billedgenerator, Wan tekst-til-billede, Wan 2.5 creator model, Alibaba AI billedmodel',

        // Open Graph
        ogTitle: 'Wan 2.5 AI-billedgenerator fra Alibaba - Gratis AI-billedværktøj',
        ogDescription:
            'Wan 2.5 fra Alibaba er en avanceret AI-billedmodel, der omsætter detaljerede ideer til præcise billeder i høj kvalitet med stærk kontrol over stil, tekstur og redigering.',

        // Twitter Card
        twitterTitle:
            'Wan 2.5 AI-billedgenerator fra Alibaba - Gratis AI-billedværktøj',
        twitterDescription:
            'Wan 2.5 fra Alibaba omsætter detaljerede ideer til præcise billeder i høj kvalitet. Prøv gratis!',

        // Additional SEO Meta
        subject: 'Wan 2.5 AI-billedgenerator fra Alibaba',
        topic: 'AI-billedgenerering, tekst-til-billede, Wan AI-model',
        coverage: 'Globalt',
        audience: 'Designere, skabere, udviklere, kunstnere',

        // Generator Section
        generatorTitle: 'Wan 2.5 AI-billedgenerator',
        generatorSubtitle:
            'Wan 2.5 fra Alibaba er en avanceret AI-billedmodel, der omsætter detaljerede ideer til præcise billeder i høj kvalitet med stærk kontrol over stil, tekstur og redigering. Prøv Wan 2.5 gratis på 微鲤AI!',

        // Core Features Section
        coreFeaturesTitle: 'Wan 2.5 kernefunktioner',
        coreFeaturesSubtitle:
            'Udforsk kernefunktionerne i Wan 2.5 AI-billedgenerator og start en revolutionerende rejse inden for AI-billedskabelse',

        // Features
        precisePromptTitle: 'Præcis prompt-følgen',
        precisePromptDesc:
            'Gengiver hver visuel instruktion nøjagtigt, fra belysning og perspektiv til tekstur og stil.',
        precisePromptAlt: 'Eksempel på præcis prompt-følgen',

        photoRealisticTitle: 'Fotorealistisk kvalitet',
        photoRealisticDesc:
            'Renderer naturtro billeder med autentisk belysning, rumlig dybde og fine teksturer.',
        photoRealisticAlt: 'Eksempel på fotorealistisk kvalitet',

        diverseStylesTitle: 'Mangfoldige kunstneriske stilarter',
        diverseStylesDesc:
            'Gengiver trofast forskellige kunststile, mens brandtone og visuelt sprog bevares.',
        diverseStylesAlt: 'Eksempel på mangfoldige kunstneriske stilarter',

        creativeTextTitle: 'Kreativ tekstgenerering',
        creativeTextDesc:
            'Designer komplekse typografier, layouts og plakatkompositioner perfekt.',
        creativeTextAlt: 'Eksempel på kreativ tekstgenerering',

        consistentElementsTitle: 'Konsistente elementer',
        consistentElementsDesc:
            'Overfører referenceelementer præcist for ensartet design og karakterer.',
        consistentElementsAlt: 'Eksempel på konsistente elementer',

        preciseEditingTitle: 'Præcis billedredigering',
        preciseEditingDesc:
            'Forstår og udfører stilændringer og kontrollerede redigeringer med høj præcision.',
        preciseEditingAlt: 'Eksempel på præcis billedredigering',

        // How to Use Section
        howToUseTitle: 'Sådan bruger du',
        howToUseSubtitle: 'Tre enkle trin til at komme i gang',

        step1Title: 'Vælg model',
        step1Description: 'Vælg Wan AI-modellen i AI-billedværktøjer',

        step2Title: 'Indtast indhold',
        step2Description: 'Indtast prompts eller upload referencebilleder',

        step3Title: 'Generér billede',
        step3Description: 'Klik på generér, vent og download dit billede',

        // YouTube Videos Section
        youtubeTitle: 'YouTube-videoer om Wan 2.5 billedmodel',

        // X Posts Section
        xPostsTitle: 'X-opslag om Wan 2.5 billedmodel',

        // Explore Other Models Section
        exploreModelsTitle: 'Udforsk andre AI-billedmodeller på 微鲤AI',
        model1Title: 'Google Nano Banana AI-billedgenerator',
        model2Title: 'FLUX AI-billedgenerator',
        model3Title: 'Google Imagen AI-billedgenerator',

        // FAQ Section
        faqTitle: 'Ofte stillede spørgsmål',

        faq1Question: 'Hvad er Wan AI?',
        faq1Answer:
            'Wan 2.5 fra Alibaba er en avanceret AI-billedmodel, der omsætter detaljerede ideer til præcise billeder i høj kvalitet med stærk kontrol over stil, tekstur og redigering.',

        faq2Question:
            'Hvilke fordele har Wan AI i forhold til andre billedgenereringsmodeller?',
        faq2Answer:
            'Wan AI har store fordele i billedkvalitet, kreativt udtryk, stilkontrol og multimodal fusion. Den kan generere professionelle billeder i høj kvalitet og understøtter kompleks kreativ udfoldelse.',

        faq3Question: 'Kan jeg bruge Wan AI gratis?',
        faq3Answer:
            'Ja. Wan AI tilbyder begrænsede gratis kreditter via WeryAIs prøveperiode. Ved omfattende brug kræves opgradering.',

        faq4Question: 'Hvilke billedformater understøtter Wan AI?',
        faq4Answer:
            'Wan AI understøtter JPG, PNG, WEBP og andre almindelige formater. De genererede billeder er i høj kvalitet og med rige detaljer.',

        faq5Question: 'Kan jeg bruge Wan AI til kommercielle projekter?',
        faq5Answer:
            'Ja. Wan AIs præcise billedgenerering og kreative udtryk gør den til et stærkt valg for designere, kunstnere og indholdsskabere, der ønsker AI-billeder i høj kvalitet til kommercielt brug.',

        // CTA Section
        ctaTitle: 'Klar til at begynde at skabe?',
        ctaDescription:
            'Prøv Wan 2.5 nu og forvandl din kreativitet til fantastiske billeder',
        ctaButton: 'Prøv Wan AI på 微鲤AI',
        ctaDisclaimer: 'Intet kreditkort kræves',
        },
    no: {
        // SEO Meta
        pageTitle: 'Wan 2.5 AI-bildegenerator fra Alibaba - Gratis AI-bildeverktøy',
        pageDescription:
            'Wan 2.5 fra Alibaba er en avansert AI-bildemodell som omdanner detaljerte ideer til presise bilder i høy kvalitet med sterk kontroll over stil, tekstur og redigering. Prøv Wan 2.5 gratis på 微鲤AI!',
        pageKeywords:
            'Wan AI, Wan 2.5 AI-modell, Alibaba Wan, Wan bildegenerator, Wan tekst-til-bilde, Wan 2.5 creator model, Alibaba AI bildemodell',

        // Open Graph
        ogTitle: 'Wan 2.5 AI-bildegenerator fra Alibaba - Gratis AI-bildeverktøy',
        ogDescription:
            'Wan 2.5 fra Alibaba er en avansert AI-bildemodell som omdanner detaljerte ideer til presise bilder i høy kvalitet med sterk kontroll over stil, tekstur og redigering.',

        // Twitter Card
        twitterTitle:
            'Wan 2.5 AI-bildegenerator fra Alibaba - Gratis AI-bildeverktøy',
        twitterDescription:
            'Wan 2.5 fra Alibaba gjør detaljerte ideer om til presise bilder i høy kvalitet. Prøv gratis!',

        // Additional SEO Meta
        subject: 'Wan 2.5 AI-bildegenerator fra Alibaba',
        topic: 'AI-bildegenerering, tekst-til-bilde, Wan AI-modell',
        coverage: 'Globalt',
        audience: 'Designere, skapere, utviklere, kunstnere',

        // Generator Section
        generatorTitle: 'Wan 2.5 AI-bildegenerator',
        generatorSubtitle:
            'Wan 2.5 fra Alibaba er en avansert AI-bildemodell som omdanner detaljerte ideer til presise bilder i høy kvalitet med sterk kontroll over stil, tekstur og redigering. Prøv Wan 2.5 gratis på 微鲤AI!',

        // Core Features Section
        coreFeaturesTitle: 'Wan 2.5 kjernefunksjoner',
        coreFeaturesSubtitle:
            'Utforsk kjernefunksjonene i Wan 2.5 AI-bildegenerator og start en revolusjonerende reise innen AI-bildeproduksjon',

        // Features
        precisePromptTitle: 'Presis prompt-etterlevelse',
        precisePromptDesc:
            'Gjengir hver visuelle instruksjon nøyaktig, fra lys og perspektiv til tekstur og stil.',
        precisePromptAlt: 'Eksempel på presis prompt-etterlevelse',

        photoRealisticTitle: 'Fotorealistisk kvalitet',
        photoRealisticDesc:
            'Renderer naturtro bilder med autentisk belysning, romlig dybde og fine teksturer.',
        photoRealisticAlt: 'Eksempel på fotorealistisk kvalitet',

        diverseStylesTitle: 'Mangfoldige kunststiler',
        diverseStylesDesc:
            'Gjengir ulike kunststiler trofast samtidig som merkevaretonen og det visuelle språket beholdes.',
        diverseStylesAlt: 'Eksempel på mangfoldige kunststiler',

        creativeTextTitle: 'Kreativ tekstgenerering',
        creativeTextDesc:
            'Utformer komplekse typografier, layouter og plakatkomposisjoner perfekt.',
        creativeTextAlt: 'Eksempel på kreativ tekstgenerering',

        consistentElementsTitle: 'Konsistente elementer',
        consistentElementsDesc:
            'Overfører referanseelementer nøyaktig for enhetlig design og karakterer.',
        consistentElementsAlt: 'Eksempel på konsistente elementer',

        preciseEditingTitle: 'Presis bilderedigering',
        preciseEditingDesc:
            'Forstår og utfører stilendringer og kontrollerte redigeringer med høy presisjon.',
        preciseEditingAlt: 'Eksempel på presis bilderedigering',

        // How to Use Section
        howToUseTitle: 'Slik bruker du',
        howToUseSubtitle: 'Tre enkle trinn for å komme i gang',

        step1Title: 'Velg modell',
        step1Description: 'Velg Wan AI-modellen i AI-bildeverktøy',

        step2Title: 'Skriv inn innhold',
        step2Description: 'Skriv inn prompts eller last opp referansebilder',

        step3Title: 'Generer bilde',
        step3Description: 'Klikk på generer, vent og last ned bildet ditt',

        // YouTube Videos Section
        youtubeTitle: 'YouTube-videoer om Wan 2.5 bildemodell',

        // X Posts Section
        xPostsTitle: 'X-innlegg om Wan 2.5 bildemodell',

        // Explore Other Models Section
        exploreModelsTitle: 'Utforsk andre AI-bildemodeller på 微鲤AI',
        model1Title: 'Google Nano Banana AI-bildegenerator',
        model2Title: 'FLUX AI-bildegenerator',
        model3Title: 'Google Imagen AI-bildegenerator',

        // FAQ Section
        faqTitle: 'Ofte stilte spørsmål',

        faq1Question: 'Hva er Wan AI?',
        faq1Answer:
            'Wan 2.5 fra Alibaba er en avansert AI-bildemodell som omdanner detaljerte ideer til presise bilder i høy kvalitet med sterk kontroll over stil, tekstur og redigering.',

        faq2Question:
            'Hvilke fordeler har Wan AI sammenlignet med andre bildemodeller?',
        faq2Answer:
            'Wan AI har store fordeler i bildekvalitet, kreativt uttrykk, stilkontroll og multimodal fusjon. Den kan generere profesjonelle bilder i høy kvalitet og støtter komplekst kreativt uttrykk.',

        faq3Question: 'Kan jeg bruke Wan AI gratis?',
        faq3Answer:
            'Ja. Wan AI tilbyr begrensede gratiskreditter via WeryAIs prøveperiode. For omfattende bruk kreves oppgradering.',

        faq4Question: 'Hvilke bildeformater støtter Wan AI?',
        faq4Answer:
            'Wan AI støtter JPG, PNG, WEBP og andre vanlige formater. Genererte bilder har høy kvalitet og rike detaljer.',

        faq5Question: 'Kan jeg bruke Wan AI til kommersielle prosjekter?',
        faq5Answer:
            'Ja. Wan AIs høy-presise bildegenerering og kreative uttrykk gjør den til et kraftig valg for designere, kunstnere og innholdsskapere som trenger AI-bilder i høy kvalitet.',

        // CTA Section
        ctaTitle: 'Klar til å begynne å skape?',
        ctaDescription:
            'Prøv Wan 2.5 nå og gjør kreativiteten din om til fantastiske bilder',
        ctaButton: 'Prøv Wan AI på 微鲤AI',
        ctaDisclaimer: 'Ingen kredittkort nødvendig',
        },
    nl: {
        // SEO Meta
        pageTitle: 'Wan 2.5 AI-beeldgenerator van Alibaba - Gratis AI-beeldtool',
        pageDescription:
            'Wan 2.5 van Alibaba is een geavanceerd AI-beeldmodel dat gedetailleerde ideeën omzet in precieze visuals van hoge kwaliteit met sterke controle over stijl, textuur en bewerking. Probeer Wan 2.5 gratis op 微鲤AI!',
        pageKeywords:
            'Wan AI, Wan 2.5 AI-model, Alibaba Wan, Wan beeldgenerator, Wan tekst-naar-beeld, Wan 2.5 creator model, Alibaba AI-beeldmodel',

        // Open Graph
        ogTitle: 'Wan 2.5 AI-beeldgenerator van Alibaba - Gratis AI-beeldtool',
        ogDescription:
            'Wan 2.5 van Alibaba is een geavanceerd AI-beeldmodel dat gedetailleerde ideeën omzet in precieze visuals van hoge kwaliteit met sterke controle over stijl, textuur en bewerking.',

        // Twitter Card
        twitterTitle:
            'Wan 2.5 AI-beeldgenerator van Alibaba - Gratis AI-beeldtool',
        twitterDescription:
            'Wan 2.5 van Alibaba zet gedetailleerde ideeën om in precieze visuals van hoge kwaliteit. Probeer gratis!',

        // Additional SEO Meta
        subject: 'Wan 2.5 AI-beeldgenerator van Alibaba',
        topic: 'AI-beeldgeneratie, tekst-naar-beeld, Wan AI-model',
        coverage: 'Wereldwijd',
        audience: 'Designers, creators, ontwikkelaars, kunstenaars',

        // Generator Section
        generatorTitle: 'Wan 2.5 AI-beeldgenerator',
        generatorSubtitle:
            'Wan 2.5 van Alibaba is een geavanceerd AI-beeldmodel dat gedetailleerde ideeën omzet in precieze visuals van hoge kwaliteit met sterke controle over stijl, textuur en bewerking. Probeer Wan 2.5 gratis op 微鲤AI!',

        // Core Features Section
        coreFeaturesTitle: 'Kernfuncties van Wan 2.5',
        coreFeaturesSubtitle:
            'Ontdek de kernfuncties van de Wan 2.5 AI-beeldgenerator en start een revolutionaire AI-beeldcreatie-reis',

        // Features
        precisePromptTitle: 'Nauwkeurige prompt-opvolging',
        precisePromptDesc:
            'Geeft elke visuele instructie nauwkeurig weer, van belichting en perspectief tot textuur en stijl.',
        precisePromptAlt: 'Voorbeeld van nauwkeurige prompt-opvolging',

        photoRealisticTitle: 'Fotorealistische kwaliteit',
        photoRealisticDesc:
            'Rendert levensechte beelden met authentieke belichting, ruimtelijke diepte en fijne texturen.',
        photoRealisticAlt: 'Voorbeeld van fotorealistische kwaliteit',

        diverseStylesTitle: 'Diverse artistieke stijlen',
        diverseStylesDesc:
            'Reproduceert verschillende artistieke stijlen getrouw terwijl toon en visuele taal van het merk behouden blijven.',
        diverseStylesAlt: 'Voorbeeld van diverse artistieke stijlen',

        creativeTextTitle: 'Creatieve tekstgeneratie',
        creativeTextDesc:
            'Ontwerpt complexe typografie, lay-outs en postercomposities perfect.',
        creativeTextAlt: 'Voorbeeld van creatieve tekstgeneratie',

        consistentElementsTitle: 'Consistente elementen',
        consistentElementsDesc:
            'Brengt referentie-elementen nauwkeurig over voor eenheid in ontwerp en personages.',
        consistentElementsAlt: 'Voorbeeld van consistente elementen',

        preciseEditingTitle: 'Nauwkeurige beeldbewerking',
        preciseEditingDesc:
            'Begrijpt en voert stijlwijzigingen en gecontroleerde bewerkingen met hoge precisie uit.',
        preciseEditingAlt: 'Voorbeeld van nauwkeurige beeldbewerking',

        // How to Use Section
        howToUseTitle: 'Zo gebruik je het',
        howToUseSubtitle: 'Drie eenvoudige stappen om te starten',

        step1Title: 'Model kiezen',
        step1Description: 'Kies het Wan AI-model in de AI-beeldtools',

        step2Title: 'Inhoud invoeren',
        step2Description: 'Voer prompts in of upload referentiebeelden',

        step3Title: 'Beeld genereren',
        step3Description: 'Klik op genereren, wacht en download je beeld',

        // YouTube Videos Section
        youtubeTitle: 'YouTube-video\'s over het Wan 2.5 beeldmodel',

        // X Posts Section
        xPostsTitle: 'X-berichten over het Wan 2.5 beeldmodel',

        // Explore Other Models Section
        exploreModelsTitle: 'Ontdek andere AI-beeldmodellen op 微鲤AI',
        model1Title: 'Google Nano Banana AI-beeldgenerator',
        model2Title: 'FLUX AI-beeldgenerator',
        model3Title: 'Google Imagen AI-beeldgenerator',

        // FAQ Section
        faqTitle: 'Veelgestelde vragen',

        faq1Question: 'Wat is Wan AI?',
        faq1Answer:
            'Wan 2.5 van Alibaba is een geavanceerd AI-beeldmodel dat gedetailleerde ideeën omzet in precieze visuals van hoge kwaliteit met sterke controle over stijl, textuur en bewerking.',

        faq2Question:
            'Welke voordelen heeft Wan AI ten opzichte van andere beeldgeneratiemodellen?',
        faq2Answer:
            'Wan AI heeft grote voordelen in beeldkwaliteit, creatieve expressie, stijlcontrole en multimodale fusie. Het kan professionele beelden van hoge kwaliteit genereren en ondersteunt complexe creatieve expressie.',

        faq3Question: 'Kan ik Wan AI gratis gebruiken?',
        faq3Answer:
            'Ja. Wan AI biedt beperkte gratis credits via 微鲤AI\'s proefperiode. Voor intensief gebruik is een upgrade nodig.',

        faq4Question: 'Welke afbeeldingsformaten ondersteunt Wan AI?',
        faq4Answer:
            'Wan AI ondersteunt JPG, PNG, WEBP en andere gangbare formaten. De gegenereerde beelden zijn van hoge kwaliteit en rijk aan detail.',

        faq5Question: 'Kan ik Wan AI gebruiken voor commerciële projecten?',
        faq5Answer:
            'Ja. De hoge precisie en creatieve mogelijkheden maken Wan AI een krachtige keuze voor ontwerpers, kunstenaars en content creators die AI-beelden van hoge kwaliteit nodig hebben.',

        // CTA Section
        ctaTitle: 'Klaar om te beginnen met creëren?',
        ctaDescription:
            'Ervaar Wan 2.5 nu en zet je creativiteit om in geweldige beelden',
        ctaButton: 'Probeer Wan AI op 微鲤AI',
        ctaDisclaimer: 'Geen creditcard vereist',
        },
    id: {
        // SEO Meta
        pageTitle: 'Generator Gambar AI Wan 2.5 dari Alibaba - Alat Gambar AI Gratis',
        pageDescription:
            'Wan 2.5 dari Alibaba adalah model gambar AI canggih yang unggul dalam mengubah ide detail menjadi visual presisi berkualitas tinggi dengan kontrol kuat atas gaya, tekstur, dan pengeditan. Coba Wan 2.5 gratis di 微鲤AI!',
        pageKeywords:
            'Wan AI, model AI Wan 2.5, Alibaba Wan, generator gambar Wan, Wan teks ke gambar, model kreator Wan 2.5, model gambar AI Alibaba',

        // Open Graph
        ogTitle: 'Generator Gambar AI Wan 2.5 dari Alibaba - Alat Gambar AI Gratis',
        ogDescription:
            'Wan 2.5 dari Alibaba adalah model gambar AI canggih yang unggul dalam mengubah ide detail menjadi visual presisi berkualitas tinggi dengan kontrol kuat atas gaya, tekstur, dan pengeditan.',

        // Twitter Card
        twitterTitle:
            'Generator Gambar AI Wan 2.5 dari Alibaba - Alat Gambar AI Gratis',
        twitterDescription:
            'Wan 2.5 dari Alibaba mengubah ide detail menjadi visual berkualitas tinggi secara presisi. Coba gratis!',

        // Additional SEO Meta
        subject: 'Generator Gambar AI Wan 2.5 dari Alibaba',
        topic: 'Generasi gambar AI, teks-ke-gambar, model Wan AI',
        coverage: 'Seluruh dunia',
        audience: 'Desainer, kreator, developer, seniman',

        // Generator Section
        generatorTitle: 'Generator Gambar AI Wan 2.5',
        generatorSubtitle:
            'Wan 2.5 dari Alibaba adalah model gambar AI canggih yang unggul dalam mengubah ide detail menjadi visual presisi berkualitas tinggi dengan kontrol kuat atas gaya, tekstur, dan pengeditan. Coba Wan 2.5 gratis di 微鲤AI!',

        // Core Features Section
        coreFeaturesTitle: 'Fitur inti Wan 2.5',
        coreFeaturesSubtitle:
            'Jelajahi fitur inti generator gambar AI Wan 2.5 dan mulai perjalanan kreasi gambar AI yang revolusioner',

        // Features
        precisePromptTitle: 'Kepatuhan prompt yang presisi',
        precisePromptDesc:
            'Merefleksikan setiap instruksi visual secara akurat, dari pencahayaan dan perspektif hingga tekstur dan gaya.',
        precisePromptAlt: 'Contoh kepatuhan prompt yang presisi',

        photoRealisticTitle: 'Kualitas fotorealistis',
        photoRealisticDesc:
            'Merender gambar realistis dengan pencahayaan autentik, kedalaman ruang, dan tekstur halus.',
        photoRealisticAlt: 'Contoh kualitas fotorealistis',

        diverseStylesTitle: 'Beragam gaya artistik',
        diverseStylesDesc:
            'Mereproduksi berbagai gaya artistik dengan setia sambil mempertahankan tone merek dan bahasa visual.',
        diverseStylesAlt: 'Contoh beragam gaya artistik',

        creativeTextTitle: 'Generasi teks kreatif',
        creativeTextDesc:
            'Merancang tipografi kompleks, tata letak, dan komposisi poster dengan sempurna.',
        creativeTextAlt: 'Contoh generasi teks kreatif',

        consistentElementsTitle: 'Elemen yang konsisten',
        consistentElementsDesc:
            'Memindahkan elemen referensi secara akurat untuk desain dan karakter yang seragam.',
        consistentElementsAlt: 'Contoh elemen yang konsisten',

        preciseEditingTitle: 'Pengeditan gambar yang presisi',
        preciseEditingDesc:
            'Memahami dan mengeksekusi perubahan gaya serta edit terkontrol dengan presisi tinggi.',
        preciseEditingAlt: 'Contoh pengeditan gambar yang presisi',

        // How to Use Section
        howToUseTitle: 'Cara menggunakan',
        howToUseSubtitle: 'Tiga langkah sederhana untuk mulai membuat',

        step1Title: 'Pilih model',
        step1Description: 'Pilih model Wan AI di alat gambar AI',

        step2Title: 'Masukkan konten',
        step2Description: 'Masukkan prompt atau unggah gambar referensi',

        step3Title: 'Buat gambar',
        step3Description: 'Klik tombol buat, tunggu, lalu unduh gambar Anda',

        // YouTube Videos Section
        youtubeTitle: 'Video YouTube tentang model gambar Wan 2.5',

        // X Posts Section
        xPostsTitle: 'Posting X tentang model gambar Wan 2.5',

        // Explore Other Models Section
        exploreModelsTitle: 'Jelajahi model gambar AI lainnya di 微鲤AI',
        model1Title: 'Generator Gambar AI Google Nano Banana',
        model2Title: 'Generator Gambar AI FLUX',
        model3Title: 'Generator Gambar AI Google Imagen',

        // FAQ Section
        faqTitle: 'Pertanyaan yang sering diajukan',

        faq1Question: 'Apa itu Wan AI?',
        faq1Answer:
            'Wan 2.5 dari Alibaba adalah model gambar AI canggih yang unggul dalam mengubah ide detail menjadi visual presisi berkualitas tinggi dengan kontrol kuat atas gaya, tekstur, dan pengeditan.',

        faq2Question:
            'Apa keunggulan Wan AI dibanding model generasi gambar lain?',
        faq2Answer:
            'Wan AI memiliki keunggulan besar dalam kualitas gambar, ekspresi kreatif, kontrol gaya, dan fusi multimodal. Model ini dapat menghasilkan gambar berkualitas profesional dan mendukung ekspresi kreatif yang kompleks.',

        faq3Question: 'Bisakah saya menggunakan Wan AI gratis?',
        faq3Answer:
            'Ya. Wan AI menyediakan kredit gratis terbatas melalui uji coba 微鲤AI. Untuk penggunaan intensif, diperlukan upgrade.',

        faq4Question: 'Format gambar apa yang didukung Wan AI?',
        faq4Answer:
            'Wan AI mendukung JPG, PNG, WEBP, dan format umum lainnya. Gambar yang dihasilkan berkualitas tinggi dan kaya detail.',

        faq5Question: 'Bisakah saya menggunakan Wan AI untuk proyek komersial?',
        faq5Answer:
            'Ya. Presisi tinggi dan kemampuan ekspresi kreatif Wan AI menjadikannya pilihan kuat bagi desainer, seniman, dan kreator konten yang membutuhkan gambar AI berkualitas tinggi.',

        // CTA Section
        ctaTitle: 'Siap mulai berkarya?',
        ctaDescription:
            'Coba Wan 2.5 sekarang dan ubah kreativitasmu menjadi gambar yang menakjubkan',
        ctaButton: 'Coba Wan AI di 微鲤AI',
        ctaDisclaimer: 'Tanpa kartu kredit',
        },
    tr: {
        // SEO Meta
        pageTitle: 'Alibaba\'dan Wan 2.5 Yapay Zeka Görsel Üreticisi - Ücretsiz AI Görsel Aracı',
        pageDescription:
            'Alibaba\'nın Wan 2.5 modeli, detaylı fikirleri stil, doku ve düzenleme üzerinde güçlü kontrolle yüksek kaliteli ve hassas görsellere dönüştüren gelişmiş bir AI görsel modelidir. 微鲤AI üzerinde Wan 2.5\'i ücretsiz deneyin!',
        pageKeywords:
            'Wan AI, Wan 2.5 AI modeli, Alibaba Wan, Wan görsel üretici, Wan metinden görsele, Wan 2.5 creator model, Alibaba AI görsel modeli',

        // Open Graph
        ogTitle: 'Alibaba\'dan Wan 2.5 Yapay Zeka Görsel Üreticisi - Ücretsiz AI Görsel Aracı',
        ogDescription:
            'Alibaba\'nın Wan 2.5 modeli, detaylı fikirleri stil, doku ve düzenleme üzerinde güçlü kontrolle yüksek kaliteli ve hassas görsellere dönüştüren gelişmiş bir AI görsel modelidir.',

        // Twitter Card
        twitterTitle:
            'Alibaba\'dan Wan 2.5 Yapay Zeka Görsel Üreticisi - Ücretsiz AI Görsel Aracı',
        twitterDescription:
            'Wan 2.5, detaylı fikirleri yüksek kaliteli görsellere dönüştürür. Ücretsiz deneyin!',

        // Additional SEO Meta
        subject: 'Alibaba\'dan Wan 2.5 Yapay Zeka Görsel Üreticisi',
        topic: 'Yapay zeka görsel üretimi, metinden görsele, Wan AI modeli',
        coverage: 'Dünya çapında',
        audience: 'Tasarımcılar, içerik üreticileri, geliştiriciler, sanatçılar',

        // Generator Section
        generatorTitle: 'Wan 2.5 Yapay Zeka Görsel Üreticisi',
        generatorSubtitle:
            'Alibaba\'nın Wan 2.5 modeli, detaylı fikirleri stil, doku ve düzenleme üzerinde güçlü kontrolle yüksek kaliteli ve hassas görsellere dönüştüren gelişmiş bir AI görsel modelidir. 微鲤AI üzerinde Wan 2.5\'i ücretsiz deneyin!',

        // Core Features Section
        coreFeaturesTitle: 'Wan 2.5 Temel Özellikleri',
        coreFeaturesSubtitle:
            'Wan 2.5 AI görsel üreticisinin temel özelliklerini keşfedin ve devrim niteliğinde bir AI görsel oluşturma yolculuğuna çıkın',

        // Features
        precisePromptTitle: 'Kesin prompt uyumu',
        precisePromptDesc:
            'Işık ve perspektiften doku ve stile kadar tüm görsel talimatları doğru yansıtır.',
        precisePromptAlt: 'Kesin prompt uyumu örneği',

        photoRealisticTitle: 'Fotogerçekçi kalite',
        photoRealisticDesc:
            'Gerçekçi ışıklandırma, uzamsal derinlik ve ince dokularla hayat gibi görseller üretir.',
        photoRealisticAlt: 'Fotogerçekçi kalite örneği',

        diverseStylesTitle: 'Çeşitli sanatsal stiller',
        diverseStylesDesc:
            'Marka tonu ve görsel dili korurken farklı sanatsal stilleri sadık biçimde üretir.',
        diverseStylesAlt: 'Çeşitli sanatsal stiller örneği',

        creativeTextTitle: 'Yaratıcı metin üretimi',
        creativeTextDesc:
            'Karmaşık tipografi, düzen ve poster kompozisyonlarını kusursuz biçimde tasarlar.',
        creativeTextAlt: 'Yaratıcı metin üretimi örneği',

        consistentElementsTitle: 'Tutarlı öğeler',
        consistentElementsDesc:
            'Referans öğeleri hassas biçimde aktararak tasarım ve karakterlerde birlik sağlar.',
        consistentElementsAlt: 'Tutarlı öğeler örneği',

        preciseEditingTitle: 'Hassas görsel düzenleme',
        preciseEditingDesc:
            'Stil değişikliklerini ve kontrollü düzenlemeleri yüksek hassasiyetle anlar ve uygular.',
        preciseEditingAlt: 'Hassas görsel düzenleme örneği',

        // How to Use Section
        howToUseTitle: 'Nasıl kullanılır',
        howToUseSubtitle: 'Başlamak için üç basit adım',

        step1Title: 'Modeli seçin',
        step1Description: 'AI görsel araçlarında Wan AI modelini seçin',

        step2Title: 'İçerik girin',
        step2Description: 'Prompt girin veya referans görseller yükleyin',

        step3Title: 'Görsel oluşturun',
        step3Description: 'Oluştur düğmesine tıklayın, bekleyin ve görselinizi indirin',

        // YouTube Videos Section
        youtubeTitle: 'Wan 2.5 görsel modeli hakkında YouTube videoları',

        // X Posts Section
        xPostsTitle: 'Wan 2.5 görsel modeli hakkında X paylaşımları',

        // Explore Other Models Section
        exploreModelsTitle: '微鲤AI\'deki diğer AI görsel modellerini keşfedin',
        model1Title: 'Google Nano Banana AI Görsel Üreticisi',
        model2Title: 'FLUX AI Görsel Üreticisi',
        model3Title: 'Google Imagen AI Görsel Üreticisi',

        // FAQ Section
        faqTitle: 'Sıkça Sorulan Sorular',

        faq1Question: 'Wan AI nedir?',
        faq1Answer:
            'Alibaba\'nın Wan 2.5 modeli, detaylı fikirleri stil, doku ve düzenleme üzerinde güçlü kontrolle yüksek kaliteli ve hassas görsellere dönüştüren gelişmiş bir AI görsel modelidir.',

        faq2Question:
            'Wan AI, diğer görsel üretim modellerine göre hangi avantajlara sahip?',
        faq2Answer:
            'Wan AI, görsel kalite, yaratıcı ifade, stil kontrolü ve çok modlu füzyonda önemli avantajlara sahiptir. Profesyonel kalitede görseller üretebilir ve karmaşık yaratıcı ifadeyi destekler.',

        faq3Question: 'Wan AI\'ı ücretsiz kullanabilir miyim?',
        faq3Answer:
            'Evet. Wan AI, 微鲤AI denemesiyle sınırlı ücretsiz kredi sunar. Yoğun kullanım için yükseltme gerekir.',

        faq4Question: 'Wan AI hangi görsel formatlarını destekler?',
        faq4Answer:
            'Wan AI, JPG, PNG, WEBP ve diğer yaygın formatları destekler. Üretilen görseller yüksek kalite ve zengin ayrıntı sunar.',

        faq5Question: 'Wan AI\'ı ticari projelerde kullanabilir miyim?',
        faq5Answer:
            'Evet. Wan AI\'ın yüksek hassasiyetli görsel üretimi ve yaratıcı ifade kabiliyeti, yüksek kaliteli AI görselleri isteyen tasarımcılar, sanatçılar ve içerik üreticileri için güçlü bir seçimdir.',

        // CTA Section
        ctaTitle: 'Oluşturmaya hazır mısınız?',
        ctaDescription:
            'Wan 2.5\'i şimdi deneyin ve yaratıcılığınızı harika görsellere dönüştürün',
        ctaButton: '微鲤AI üzerinde Wan AI\'ı deneyin',
        ctaDisclaimer: 'Kredi kartı gerekmez',
        },
}
